<template>
  <div class="page" :class="bgImageClass">
    <div class="content">
      <div :class="'left-location-' + people">
        <van-image
          :src="leftPeople"
          v-if="leftPeople && isLeftPeople"
          class="left-people fast animated"
          :class="
            'left-people-' +
              noticeStep +
              (+noticeStep % 2 === 0 ? ' slideInLeft' : ' slideInRight')
          "
        />
      </div>

      <div :class="'right-location-' + people">
        <van-image
          :src="rightPeople"
          v-if="rightPeople && isRightPeople"
          class="right-people fast animated"
          :class="
            'right-people-' +
              noticeStep +
              (+noticeStep % 2 === 0 ? ' fadeInRight' : ' fadeInLeft')
          "
        />
      </div>

      <div class="right-location-hr" style="bottom: 0">
        <van-image
          :src="hrPeople"
          v-if="isRightPeopleHr"
          class="right-people fadeInRight animated"
        />
      </div>

      <div class="select-cover" v-if="showCover"></div>

      <div
        class="select-cover-power"
        v-if="showPowerCover"
        @click="handleSelectResultPage()"
      ></div>

      <div class="city" v-if="noticeStep === 40">
        <van-row gutter="5">
          <van-col span="12" class="left">
            <div class="sh001">
              <img
                src="../assets/images/city/sh001.png"
                @click="showCity('sh001')"
                ref="sh001"
                @load="loadCityImage('sh001')"
              />
            </div>
            <div class="bj002">
              <img
                src="../assets/images/city/bj002.png"
                @click="showCity('bj002')"
                ref="bj002"
                @load="loadCityImage('bj002')"
              />
            </div>
          </van-col>
          <van-col span="12" class="right">
            <div class="sh002">
              <img
                src="../assets/images/city/sh002.png"
                @click="showCity('sh002')"
                ref="sh002"
                @load="loadCityImage('sh002')"
              />
            </div>
            <div class="bj001">
              <img
                src="../assets/images/city/bj001.png"
                @click="showCity('bj001')"
                ref="bj001"
                @load="loadCityImage('bj001')"
              />
            </div>
            <div class="sz001">
              <img
                src="../assets/images/city/sz001.png"
                @click="showCity('sz001')"
                ref="sz001"
                @load="loadCityImage('sz001')"
              />
            </div>
          </van-col>
        </van-row>
        <!--<template v-if="city.sh001.style">
          <div
            class="mock-btn sh001-btn"
            @click="showCity('sh001')"
            :style="city.sh001.style"
          ></div>
          <div
            class="mock-btn sh002-btn"
            @click="showCity('sh002')"
            :style="city.sh002.style"
          ></div>
          <div
            class="mock-btn bj001-btn"
            @click="showCity('bj001')"
            :style="city.bj001.style"
          ></div>
          <div
            class="mock-btn bj002-btn"
            @click="showCity('bj002')"
            :style="city.bj002.style"
          ></div>
          <div
            class="mock-btn sz001-btn"
            @click="showCity('sz001')"
            :style="city.sz001.style"
          ></div>
        </template>-->
      </div>

      <div class="overlay" v-if="showNotice">
        <div v-if="noticeStep === 1" style="margin-bottom:110px">
          <div v-html="getStepContent(1)" class="popup popup-msg-3 slow fadeInUp animated">
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(2)"
            >
              很高兴认识你！
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/1.png" />
              <img v-else src="../assets/images/step/f.1.png" />
            </div>
          </div>
        </div>

        <div v-else-if="noticeStep === 2" style="margin-bottom:110px">
          <div v-html="getStepContent(1)" class="mock-game-msg popup-msg-3 animated flipOutX faster">
          </div>
          <div v-html="getStepContent(2)" class="popup popup-msg-5 fast flipInX animated">
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(3)"
            >
              好的，我记住了
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/1.png" />
              <img v-else src="../assets/images/step/f.1.png" />
            </div>
          </div>
        </div>

        <div v-else-if="noticeStep === 3" style="margin-bottom:110px">
          <div v-html="getStepContent(2)" class="mock-game-msg popup-msg-5 animated flipOutY faster">
          </div>
          <div v-html="getStepContent(3)" class="popup popup-1 popup-msg-3 fast flipInY animated">
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(4)"
            >
              谢谢！我会联系TA的
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/1.png" />
              <img v-else src="../assets/images/step/f.1.png" />
            </div>
          </div>
        </div>

        <div v-else-if="noticeStep === 4" style="margin-bottom:110px">
          <div v-html="getStepContent(3)" class="mock-game-msg popup-msg-3 animated flipOutX faster">
          </div>
          <div class="popup popup-msg-9 fast flipInX animated">
            <span v-html="getStepContent(4)"></span>
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(5)"
            >
              Let's Go！
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/1.png" />
              <img v-else src="../assets/images/step/f.1.png" />
            </div>
          </div>
        </div>

        <div v-else-if="noticeStep === 5" style="margin-bottom: 110px;">
          <div class="mock-game-msg popup-msg-9 faster flipOutY animated">
            <span v-html="getStepContent(4)"></span>
          </div>
          <div v-html="getStepContent(5)" class="popup popup-msg-7 fast flipInY animated">
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(36)"
            >
              好的！
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/1.png" />
              <img v-else src="../assets/images/step/f.1.png" />
            </div>
          </div>
        </div>

        <div v-else-if="noticeStep === 36" style="margin-bottom: 110px;">
          <div class="mock-game-msg popup-msg-7 faster flipOutY animated">
            <span v-html="getStepContent(5)"></span>
          </div>
          <div v-html="getStepContent(36)" class="popup popup-msg-7 fast flipInY animated">
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(6)"
            >
              听上去不错！
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/1.png" />
              <img v-else src="../assets/images/step/f.1.png" />
            </div>
          </div>
        </div>

        <div v-else-if="noticeStep === 6" style="margin-bottom:110px">
          <div v-html="getStepContent(5)" class="mock-game-msg popup-msg-7 faster flipOutY animated">
          </div>
          <div v-html="getStepContent(6)" class="popup popup-1 popup-msg-2 fast flipInX animated">
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn gray-btn"
              @click="nextNotice(8)"
            >
              稍后再看
            </van-button>
            <!--<van-button slot="button" size="small" type="default" class="black-btn step-btn" @click="nextNotice(7)">-->
            <!--我来看看-->
            <!--</van-button>-->
          </div>
          <div class="background-video-btn" @click="nextNotice(7)"></div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/1.png" />
              <img v-else src="../assets/images/step/f.1.png" />
            </div>
          </div>
        </div>

        <div v-else-if="noticeStep === 8" style="margin-bottom:110px">
          <div v-html="getStepContent(6)" class="mock-game-msg popup-msg-2 faster flipOutY animated">
          </div>
          <div class="popup popup-msg-3 fast flipInY animated">
            <span v-html="getStepContent(8)"></span>
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(9)"
            >
              太棒了！
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/2_h.png" />
              <img v-else src="../assets/images/step/f.2.png" />
            </div>
          </div>
        </div>

        <div v-else-if="noticeStep === 9" style="margin-bottom:110px">
          <div class="mock-game-msg popup-msg-3 faster flipOutX animated">
            <span v-html="getStepContent(8)"></span>
          </div>
          <div class="popup popup-1 popup-msg-3 fast flipInX animated">
            <span v-html="getStepContent(9)"></span>
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(10)"
            >
              探索一下
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/2_h.png" />
              <img v-else src="../assets/images/step/f.2.png" />
            </div>
          </div>
        </div>

        <div v-else-if="noticeStep === 11" style="margin-bottom:110px;">
          <div class="mock-game-msg popup-msg-3 faster flipOutY animated">
            <span v-html="getStepContent(9)"></span>
          </div>
          <div v-html="getStepContent(11)" class="popup popup-1 popup-msg-7 fast flipInY animated">
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(12)"
            >
              好的
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/3.png" />
              <img v-else src="../assets/images/step/f.3.png" />
            </div>
          </div>
        </div>

        <div
          v-else-if="noticeStep === 12"
          style="min-height: 90px;margin-bottom:160px"
        >
          <div
            v-html="getStepContent(11)"
            class="mock-game-msg popup-msg-7 faster flipOutX animated"
            style="min-height:200px;"
          >
          </div>
          <div v-html="getStepContent(12)" class="popup popup-1 popup-msg-2 fast flipInX animated">
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(40)"
            >
              走近各地WeWork空间
            </van-button>
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn white-btn"
              style="margin-top:10px"
              @click="nextNotice(40)"
            >
              了解了 </van-button
            >`
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/3.png" />
              <img v-else src="../assets/images/step/f.3.png" />
            </div>
          </div>
        </div>
        <div
          v-else-if="noticeStep === 40"
          style="min-height: 90px;margin-bottom:110px"
        >
          <div class="mock-game-msg popup-msg-3 faster flipOutY animated">
            <span v-html="getStepContent(12)"></span>
          </div>
          <div class="popup popup-1 popup-msg-7 fast flipInY animated">
            <span v-html="getStepContent(40)"></span>
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(13)"
            >
              好的
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/3.png" />
              <img v-else src="../assets/images/step/f.3.png" />
            </div>
          </div>
        </div>
        <div
          v-else-if="noticeStep === 13"
          style="min-height: 90px;margin-bottom:110px"
        >
          <div v-html="getStepContent(12)" class="mock-game-msg popup-msg-2 faster flipOutY animated"></div>
          <div class="popup popup-1 popup-msg-3 fast flipInY animated">
            <span v-html="getStepContent(13)"></span>
          </div>
          <div class="popup-btn">
            <!-- TODO -->
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(staffType === 'OFFICIAL'? 14 : 16)"
            >
              对的
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/3.png" />
              <img v-else src="../assets/images/step/f.3.png" />
            </div>
          </div>
        </div>
        <div v-else-if="noticeStep === 14" style="margin-bottom: 110px;">
          <div class="mock-game-msg popup-msg-3 faster flipOutX animated">
            <span v-html="getStepContent(13)"></span>
          </div>
          <div class="popup popup-1 popup-msg-2 fast flipInX animated">
            <span v-html="getStepContent(14)"></span>
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(15)"
            >
              探索一下
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img src="../assets/images/step/4.png" />
            </div>
          </div>
        </div>
        <div
          v-else-if="noticeStep === 16"
          style="min-height:110px;margin-bottom:110px"
        >
          <div class="mock-game-msg popup-msg-2 faster flipOutY animated">
            <span v-html="getStepContent(14)"></span>
          </div>
          <div class="popup popup-msg-5 fast flipInY animated">
            <span v-html="getStepContent(16)"></span>
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(17)"
            >
              开始台卡DIY
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/5_h.png" />
              <img v-else src="../assets/images/step/f.4.png" />
            </div>
          </div>
        </div>
        <div v-else-if="noticeStep === 21" style="margin-bottom:110px">
          <div class="mock-game-msg popup-msg-5 faster flipOutX animated">
            <span v-html="getStepContent(16)"></span>
          </div>
          <div class="popup popup-msg-5 fast flipInX animated" v-html="getStepContent(21)"></div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(staffType === 'INFORMALITY' ? 29 : 25)"
            >
              好的
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/6.png" />
              <img v-else src="../assets/images/step/f.4.png" />
            </div>
          </div>
        </div>
        <div v-else-if="noticeStep === 29" style="margin-bottom: 110px;">
          <div class="popup popup-msg-6 fadeInUp animated">
            Hey！我是People团队的Vivian。
            欢迎开启创造者之旅！经过刚才的参观，想必你对WeWork应该有了很多了解。
            如果后续还有入职相关问题，可以直接联系我们哦！我们的邮箱是{{
              notice.hr.email
            }}。 期待你的到来！
          </div>
          <div class="popup-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="black-btn step-btn"
              @click="nextNotice(24)"
            >
              Day 1 见！
            </van-button>
          </div>
          <div class="popup-step">
            <div class="process">
              <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/7.png" />
              <img v-else src="../assets/images/step/f.4.png" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="noticeStep === 7">
        <div
          class="introduction-video-btn"
          @click="handleIntroductionVideo"
        ></div>
        <div class="next-page" @click="nextNotice(8)">
          下一页
        </div>
      </div>
      <div v-else-if="noticeStep === 10">
        <div class="light">
          <div class="jin1 infinite tada animated slow" @click="showLight(1)">
            <img src="../assets/images/light/point.png" class="point" />
            <img src="../assets/images/light/jin1.png" class="jin" />
          </div>
          <!--<div class="jin3 infinite tada animated slow delay-1s" @click="showLight(3)">-->
          <!--<img src="../assets/images/light/point.png" class="point">-->
          <!--<img src="../assets/images/light/jin3.png" class="jin">-->
          <!--</div>-->
          <!-- <div class="jin5 infinite tada animated slow" @click="showLight(5)">
            <img src="../assets/images/light/point.png" class="point" />
            <img src="../assets/images/light/jin5.png" class="jin" />
          </div> -->
          <div class="jin6 infinite tada animated slow" @click="showLight(6)">
            <img src="../assets/images/light/point.png" class="point" />
            <img src="../assets/images/light/jin6.png" class="jin" />
          </div>
          <div
            class="jin4 infinite rubberBand animated slow"
            @click="showLight(4)"
          >
            <img src="../assets/images/light/point.png" class="point" />
            <img src="../assets/images/light/jin4.png" class="jin" />
          </div>
          <div
            class="jin2 infinite heartBeat animated slow"
            @click="showLight(2)"
          >
            <img src="../assets/images/light/point.png" class="point" />
            <img
              src="../assets/images/light/jin2.png"
              class="jin"
              style="width:160%"
            />
          </div>
        </div>
        <div class="popup-btn">
          <van-button
            slot="button"
            size="small"
            type="default"
            class="black-btn step-btn white-btn"
            @click="nextNotice(11)"
          >
            继续
          </van-button>
        </div>
        <div class="popup-step">
          <div class="process">
            <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/2.png" />
            <img v-else src="../assets/images/step/f.2.png" />
          </div>
        </div>
      </div>
      <div v-else-if="noticeStep === 15">
        <div class="light">
          <div class="jin7 infinite tada animated slow" @click="showLight(7)">
            <img src="../assets/images/light/point.png" class="point" />
            <img src="../assets/images/light/jin7.png" class="jin" />
          </div>
          <div class="jin8 infinite tada animated slow" @click="showLight(8)">
            <img src="../assets/images/light/point.png" class="point" />
            <img
              src="../assets/images/light/jin8.png"
              class="jin"
              style="width:160%"
            />
          </div>
          <div class="jin9 infinite tada animated slow" @click="showLight(9)">
            <img src="../assets/images/light/point.png" class="point" />
            <img src="../assets/images/light/jin9.png" class="jin" />
          </div>
          <div class="jin10 infinite tada animated slow" @click="showLight(10)">
            <img src="../assets/images/light/point.png" class="point" />
            <img src="../assets/images/light/jin10.png" class="jin" />
          </div>
          <div
            class="jin11 infinite rubberBand animated slow"
            @click="showLight(11)"
          >
            <img src="../assets/images/light/point.png" class="point" />
            <img src="../assets/images/light/jin11.png" class="jin" />
          </div>
          <div
            class="jin12 infinite heartBeat animated slow"
            @click="showLight(12)"
          >
            <img src="../assets/images/light/point.png" class="point" />
            <img
              src="../assets/images/light/jin12.png"
              class="jin"
              style="width:160%"
            />
          </div>
        </div>
        <div class="popup-btn">
          <van-button
            slot="button"
            size="small"
            type="default"
            class="black-btn step-btn white-btn"
            @click="nextNotice(16)"
          >
            继续
          </van-button>
        </div>
        <div class="popup-step">
          <div class="process">
            <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/5.png" />
            <img v-else src="../assets/images/step/f.4.png" />
          </div>
        </div>
      </div>
      <div v-else-if="noticeStep === 17">
        <div class="card-page-step">
          <div class="select-style-diy card-tips">
            <!--<img src="../assets/images/select_style_diy.png" />-->
            专属台卡定制1/4: 选择底板
          </div>
          <div class="card-style-body">
            <div class="select-style">
              {{cardName ? cardName : '请选择你喜欢的风格'}}
            </div>
            <div class="card-style-list">
              <van-row>
                <van-col span="12">
                  <img
                    :class="templateStyle === 'card1' ? 'card-selected' : ''"
                    src="../assets/images/card1.png"
                    @click="handleSelectCard('card1')"
                  />
                </van-col>
                <van-col span="12">
                  <img
                    :class="templateStyle === 'card2' ? 'card-selected' : ''"
                    src="../assets/images/card2.png"
                    @click="handleSelectCard('card2')"
                  />
                </van-col>
              </van-row>
              <van-row>
                <van-col span="12">
                  <img
                    :class="templateStyle === 'card3' ? 'card-selected' : ''"
                    src="../assets/images/card3.png"
                    @click="handleSelectCard('card3')"
                  />
                </van-col>
                <van-col span="12">
                  <img
                    :class="templateStyle === 'card4' ? 'card-selected' : ''"
                    src="../assets/images/card4.png"
                    @click="handleSelectCard('card4')"
                  />
                </van-col>
              </van-row>
              <van-row>
                <van-col span="12">
                  <img
                    :class="templateStyle === 'card5' ? 'card-selected' : ''"
                    src="../assets/images/card5.png"
                    @click="handleSelectCard('card5')"
                  />
                </van-col>
                <van-col span="12">
                  <img
                    :class="templateStyle === 'card6' ? 'card-selected' : ''"
                    src="../assets/images/card6.png"
                    @click="handleSelectCard('card6')"
                  />
                </van-col>
              </van-row>
              <van-row>
                <van-col span="12">
                  <img
                    :class="templateStyle === 'card7' ? 'card-selected' : ''"
                    src="../assets/images/card7.png"
                    @click="handleSelectCard('card7')"
                  />
                </van-col>
                <van-col span="12">
                  <img
                    :class="templateStyle === 'card8' ? 'card-selected' : ''"
                    src="../assets/images/card8.png"
                    @click="handleSelectCard('card8')"
                  />
                </van-col>
              </van-row>
              <van-row>
                <van-col span="12">
                  <img
                    :class="templateStyle === 'card9' ? 'card-selected' : ''"
                    src="../assets/images/card9.png"
                    @click="handleSelectCard('card9')"
                  />
                </van-col>
                <van-col span="12">
                  <img
                    :class="templateStyle === 'card10' ? 'card-selected' : ''"
                    src="../assets/images/card10.png"
                    @click="handleSelectCard('card10')"
                  />
                </van-col>
              </van-row>
            </div>
          </div>
          <div class="card-style-btn">
            <!--<van-button
              slot="button"
              size="small"
              type="default"
              class="prev-btn"
              @click="nextNotice(17)"
            >
              回到上一步
            </van-button>-->
            <van-button
              slot="button"
              size="small"
              type="default"
              class="next-btn"
              @click="nextNotice(18)"
            >
              下一步
            </van-button>
          </div>
        </div>
        <div class="popup-step height-hide-scroll">
          <div class="process">
            <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/5.png" />
            <img v-else src="../assets/images/step/f.4.png" />
          </div>
        </div>
      </div>

      <div v-if="noticeStep === 18">
        <div class="card-page-step">
          <div class="select-style-diy card-tips">
            <!--<img src="../assets/images/select_style_diy.png" />-->
            专属台卡定制2/4: 上传头像
          </div>
          <div class="card-style-body">
            <div class="select-style">
              请把你近期最好看的照片<br />
              亮出来！
            </div>
            <div class="card-style-list">
              <div class="user-add-photo">
                <div v-if="uploadCollection.user">
                  <img
                    src="../assets/images/close.png"
                    class="user-upload-close-btn"
                    @click="closeImage('user')"
                  />
                  <img :src="uploadCollection.user" class="preview-img" />
                </div>

                <div class="user-image-upload" v-else>
                  <img src="../assets/images/user.png" />
                  <H5Cropper
                    :autoCropWidth="200"
                    :autoCropHeight="200"
                    :canMoveBox="true"
                    :fixed="true"
                    :fixedBox="false"
                    :isCircle="true"
                    :otherData="{ name: 'user', index: 0 }"
                    @getbase64Data="uploadImageNew"
                  >
                  </H5Cropper>
                </div>
              </div>
            </div>
          </div>
          <div class="card-style-btn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="prev-btn"
              @click="nextNotice(17)"
            >
              回到上一步
            </van-button>
            <van-button
              slot="button"
              size="small"
              type="default"
              class="next-btn"
              @click="nextNotice(19)"
            >
              下一步
            </van-button>
          </div>
        </div>
        <div class="popup-step">
          <div class="process">
            <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/5.png" />
            <img v-else src="../assets/images/step/f.4.png" />
          </div>
        </div>
      </div>
      <!-- TODO 标签 -->
      <div v-if="noticeStep === 19">
        <div class="card-page-step">
          <div class="select-style-diy card-tips">
            <!--<img src="../assets/images/select_style_diy.png" />-->
            专属台卡定制3/4: 个性标签
          </div>
          <div class="card-style-body" style="padding-bottom: 4%;">
            <div class="select-style">
              #我的个性标签#
            </div>
            <div class="card-style-list">
              <van-row
                gutter="5"
                v-for="(tags, index) in userTag.length"
                :key="index"
              >
                <van-col span="12" v-for="(tag, ti) in userTag[tags]" :key="ti">
                  <template v-if="!tag.edit">
                    <div
                      class="card-style-icon"
                      @click="handleSelectTag(tag)"
                      :class="tag.selected ? 'icon-selected' : ''"
                    >
                      <div class="title">#{{ tag.name }}#</div>
                      <div class="icon">
                        <img v-if="tag.img" :src="tag.img" />
                        <div @click.stop="handleEdit(tag)" v-if="!tag.img && !tag.selected">编辑</div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="card-style-icon">
                      <input @blur="handleTagInputBlur(tag)" v-model="tag.name" type="text" placeholder="#自定义#">
                    </div>
                  </template>
                </van-col>
              </van-row>
            </div>
          </div>
          <div
            class="card-style-btn height-hide-scroll-btn"
            style="margin-bottom: 50px;"
          >
            <van-button
              slot="button"
              size="small"
              type="default"
              class="prev-btn"
              @click="nextNotice(18)"
            >
              回到上一步
            </van-button>
            <van-button
              slot="button"
              size="small"
              type="default"
              class="next-btn"
              @click="nextNotice(20)"
            >
              下一步
            </van-button>
          </div>
        </div>
        <div class="popup-step height-hide-scroll">
          <div class="process">
            <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/5.png" />
            <img v-else src="../assets/images/step/f.4.png" />
          </div>
        </div>
      </div>

      <div v-if="noticeStep === 20">
        <div class="card-page-step">
          <div class="select-style-diy card-tips">
            专属台卡定制4/4: 自我介绍
          </div>
          <!--<div class="select-style-diy">-->
          <!--<img src="../assets/images/my_introduction.png" style="width:95%;" />-->
          <!--</div>-->
          <div class="card-style-body">
            <div class="select-style">
              <!--#个人宣言#<br>-->
              <!--#我的自我介绍#<br>-->
              <img
                src="../assets/images/you.png"
                style="margin-top: 20px;"
              /><br />
              <!--                            <span style="color:#553d40;font-size:14px;">-->
              <!--                                English preferred,<br>-->
              <!--                                since it will be visible company-wide;-->
              <!--                            </span>-->
              <!--<span style="color:#553d40;font-size:12px;">（请用英文填写，50~200字）</span>-->
            </div>
            <div class="card-style-list" style="min-height: 180px">
              <van-field
                v-model="peopleDeclaration"
                rows="6"
                :autosize="{ lineHeight: 32, minHeight: 220 }"
                type="textarea"
                minlength="50"
                maxlength="200"
                :show-word-limit="true"
                class="people-declaration"
              />
            </div>
          </div>
          <div class="card-style-btn" style="margin-bottom: 50px;">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="prev-btn"
              @click="nextNotice(19)"
            >
              回到上一步
            </van-button>
            <van-button
              slot="button"
              size="small"
              type="default"
              class="next-btn"
              @click="nextNotice(35)"
            >
              下一步
            </van-button>
          </div>
        </div>
        <div class="popup-step" v-show="showFooterStep">
          <div class="process">
            <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/5.png" />
            <img v-else src="../assets/images/step/f.4.png" />
          </div>
        </div>
      </div>

      <div v-if="noticeStep === 35">
        <div class="card-page-step">
          <div class="select-style-diy">
            <img src="../assets/images/dsd.png" style="width:55%" />
          </div>
          <div class="card-style-body">
            <div
              class="card-style-list"
              style="min-height: 150px; margin-bottom: 10px"
            >
              <input
                type="text"
                v-model="loveMusic.one"
                maxlength="50"
                class="people-music"
              />
              <input
                type="text"
                v-model="loveMusic.two"
                maxlength="50"
                class="people-music"
              />
            </div>
          </div>
          <div class="card-style-btn" style="margin-bottom: 50px;">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="prev-btn"
              @click="nextNotice(20)"
            >
              回到上一步
            </van-button>
            <van-button
              slot="button"
              size="small"
              type="default"
              class="next-btn"
              @click="nextNotice(30)"
            >
              下一步
            </van-button>
          </div>
        </div>
        <div class="popup-step" v-show="showFooterStep">
          <div class="process">
            <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/5.png" />
            <img v-else src="../assets/images/step/f.4.png" />
          </div>
        </div>
      </div>

      <div v-if="noticeStep === 22">
        <div style="width:100%;height:20px;"></div>
        <div
          class="upload-info card-page-step"
          style="position: relative;left:0;"
        >
          <div class="upload-info-close-btn">
            <img src="../assets/images/guan2.png" @click="nextNotice(21)" />
          </div>
          <div
            class="upload-item upload-info-cert"
            style="margin-top: 0px; padding-top: 20px"
          >
            <div class="title">
              请上传清晰的有效ID图片<br />
              <span class="small">（中国大陆公民请上传身份证正反面）</span>
            </div>
            <div class="upload-area" v-for="c in certPhotoCount" :key="c">
              <div class="upload-area-inner">
                <div v-if="uploadCollection.cert && uploadCollection.cert[c]">
                  <img
                    src="../assets/images/close.png"
                    class="upload-close-btn"
                    @click="closeImage('cert', c)"
                  />
                  <img
                    :src="uploadCollection.cert[c]"
                    class="preview-img"
                    :style="
                      serverCollection.cert &&
                      serverCollection.cert[c] &&
                      serverCollection.cert[c].indexOf('.pdf') > -1
                        ? 'width:auto!important'
                        : ''
                    "
                  />
                </div>

                <div v-else class="upload-label-new">
                  <img src="../assets/images/upload.png" />
                  <H5Cropper
                    :autoCropWidth="300"
                    :autoCropHeight="200"
                    :canMoveBox="true"
                    :fixed="false"
                    :fixedBox="false"
                    :isCircle="false"
                    :otherData="{
                      format: 'application/pdf',
                      name: 'cert',
                      index: c,
                    }"
                    @getbase64Data="uploadImageNew"
                  >
                  </H5Cropper>
                </div>
              </div>
            </div>
            <div class="upload-area-add" @click="certPhotoCount++">
              <img src="../assets/images/upload_add.png" /> 增加上传画面
            </div>
          </div>
          <div class="upload-item upload-info-edu">
            <div class="title">
              请上传你最高学历的证明副本
            </div>
            <div class="upload-area" v-for="c in eduPhotoCount" :key="c">
              <div class="upload-area-inner">
                <div v-if="uploadCollection.edu && uploadCollection.edu[c]">
                  <img
                    src="../assets/images/close.png"
                    class="upload-close-btn"
                    @click="closeImage('edu', c)"
                  />
                  <img
                    :src="uploadCollection.edu[c]"
                    class="preview-img"
                    :style="
                      serverCollection.edu &&
                      serverCollection.edu[c] &&
                      serverCollection.edu[c].indexOf('.pdf') > -1
                        ? 'width:auto!important'
                        : ''
                    "
                  />
                </div>

                <div v-else class="upload-label-new">
                  <img src="../assets/images/upload.png" />
                  <H5Cropper
                    :autoCropWidth="300"
                    :autoCropHeight="200"
                    :canMoveBox="true"
                    :fixed="false"
                    :fixedBox="false"
                    :isCircle="false"
                    :otherData="{
                      format: 'application/pdf',
                      name: 'edu',
                      index: c,
                    }"
                    @getbase64Data="uploadImageNew"
                  >
                  </H5Cropper>
                </div>
              </div>
            </div>
            <div class="upload-area-add" @click="eduPhotoCount++">
              <img src="../assets/images/upload_add.png" /> 增加上传画面
            </div>
          </div>
          <div
            class="upload-item upload-info-report"
            v-if="onBoardDto.w12 || onBoardDto.w13"
          >
            <div class="title">
              请上传最近三个月内的体检报告<br />
              <span class="small"
                >（如果暂时没有，请务必查看下方体 检说明预约入职体检～）</span
              >
            </div>
            <div class="upload-area" v-for="c in reportPhotoCount" :key="c">
              <div class="upload-area-inner">
                <div
                  v-if="uploadCollection.report && uploadCollection.report[c]"
                >
                  <img
                    src="../assets/images/close.png"
                    class="upload-close-btn"
                    @click="closeImage('report', c)"
                  />
                  <img
                    :src="uploadCollection.report[c]"
                    class="preview-img"
                    :style="
                      serverCollection.report &&
                      serverCollection.report[c] &&
                      serverCollection.report[c].indexOf('.pdf') > -1
                        ? 'width:auto!important'
                        : ''
                    "
                  />
                </div>

                <div v-else class="upload-label-new">
                  <img src="../assets/images/upload.png" />
                  <H5Cropper
                    :autoCropWidth="300"
                    :autoCropHeight="200"
                    :canMoveBox="true"
                    :fixed="false"
                    :fixedBox="false"
                    :isCircle="false"
                    :otherData="{
                      format: 'application/pdf',
                      name: 'report',
                      index: c,
                    }"
                    @getbase64Data="uploadImageNew"
                  >
                  </H5Cropper>
                </div>
              </div>
            </div>
            <div class="upload-area-add" @click="reportPhotoCount++">
              <img src="../assets/images/upload_add.png" /> 增加上传画面
            </div>
          </div>
          <div
            class="upload-item join-job-btn"
            @click="showReport = !showReport"
            v-if="onBoardDto.w12 || onBoardDto.w13"
          >
            入职体检政策
            <img src="../assets/images/arrow_up.png" v-if="showReport" />
            <img src="../assets/images/arrow_down.png" v-else />
          </div>
          <div
            class="upload-item upload-info-description"
            v-show="showReport"
            v-if="onBoardDto.w12 || onBoardDto.w13"
          >
            <p>入职体检须知：</p>
            <p>
              <span class="content"
                >欢迎你即将加入WeWork的大家庭!在此之前，我们推荐你到公司合作的体检机构在各城市的体检中心完成入职体检。​扫描下方二维码注册，预约并完成付款​。​发票（使用Offer上的公司主体抬头，具体信息详见小贴士4）将于体检完成后10工作日寄出​，​请注意保留用于入职后报销。</span
              >
            </p>
            <p>
              <span class="content"
                ><img src="../assets/images/tijian.png" style="width: 70%;"
              /></span>
            </p>
            <p>
              <span class="content"
                >自行体检须知<br />
                1. 体检报销 Max 220人民币<br />
                2. 发票抬头必须与Offer劳动主体保持一致<br />
                3. 公立医院二甲及以上或者大型连锁体检机构</span
              >
            </p>
            <p>
              <span class="content"
                >*
                距离你入职日期90天内的体检报告都视为有效，可直接上传清晰照片/扫描件，无需再次体检。</span
              >
            </p>
            <p>
              <span class="content"
                ><span class="dot"></span>公司合作体检中心热线<br />Amy
                Dong(董丽)：<br />座机 021-8023-1900*871<br />电子邮箱
                amy.dong@ehnasia.com</span
              >
            </p>
            <p>
              <span class="content"
                ><span class="dot"></span
                >体检须知为了更准确地反映你身体的真实情况，请你注意以下内容：</span
              >
            </p>
            <br />
            <p>饮食原则</p>
            <p>
              <span class="content"
                >1）体检前三天应注意饮食均衡，如需做大便潜血检查需素食饮食，避免吃血制品、动物内脏、菠菜等。</span
              >
            </p>
            <p>
              <span class="content"
                >2）体检前一天清淡饮食、勿饮酒、喝浓茶和咖啡，不要吃对肝、肾功能有损害的药物（降压药、降糖药除外），晚八点后禁食，保证空腹10-12小时抽血检验。</span
              >
            </p>
            <p>
              <span class="content"
                >3）体检前一天要注意休息，避免过度疲劳，剧烈运动和情绪激动，以免影响体检结果。</span
              >
            </p>
            <p>
              <span class="content"
                >4）体检的当日晨禁食、禁水；在抽血、腹部彩超、碳13检查后方可进食；如患有糖尿病、冠心病、高血压等慢性疾病，请正常服药（少量水），并告知医生。</span
              >
            </p>
            <p>
              <span class="content"
                >5）体检当日请着宽松轻便服装，不要穿带金属扣的内衣，不要佩戴首饰，以免影响放射检查；请勿携带贵重物品。</span
              >
            </p>
            <p>
              <span class="content"
                >6）抽血时间最好在早上8点至9点，最迟不宜超过10点半，以保证检验结果的准确性。</span
              >
            </p>
            <br />
            <p>女性注意</p>
            <p>
              <span class="content"
                >1）怀孕或可能已受孕的女性，请预先告知医护人员，避免进行X光检查。</span
              >
            </p>
            <br />
            <p>特殊人群</p>
            <p>
              <span class="content"
                >1）患有糖尿病、冠心病等慢性病患者，请随身携带常规（急救）药品。</span
              >
            </p>
            <p>
              <span class="content"
                >2）做餐后2小时血糖者，做完空腹项目后吃二两馒头（从吃第一口计时）2小时后抽血。</span
              >
            </p>
            <p>
              <span class="content"
                >3）体检时请向医生告知你的不适和曾患疾病，以便注意重点检查，综合分析和评估。</span
              >
            </p>
            <p>
              <span class="content"
                >体检中心将在体检完成后的一至两个工作日内短信通知领取体检报告。届时请注意查收短信，并按照短信说明查看报告。</span
              >
            </p>
          </div>
          <div class="upload-item upload-info-leave">
            <div class="title">
              请上传上家公司的离职证明<br />（或退工单）照片
            </div>

            <input
              type="checkbox"
              v-model="isGraduate"
              value="1"
              id="isGraduate"
            /><label for="isGraduate">我是应届生，无须提交离职证明</label>
            <div
              class="upload-area"
              v-for="c in leavePhotoCount"
              :key="c"
              :style="isGraduate ? 'opacity:0.5' : ''"
            >
              <div class="upload-area-inner">
                <div v-if="uploadCollection.leave && uploadCollection.leave[c]">
                  <img
                    src="../assets/images/close.png"
                    class="upload-close-btn"
                    @click="closeImage('leave', c)"
                  />
                  <img
                    :src="uploadCollection.leave[c]"
                    class="preview-img"
                    :style="
                      serverCollection.leave &&
                      serverCollection.leave[c] &&
                      serverCollection.leave[c].indexOf('.pdf') > -1
                        ? 'width:auto!important'
                        : ''
                    "
                  />
                </div>

                <div v-else class="upload-label-new">
                  <img src="../assets/images/upload.png" />
                  <H5Cropper
                    :autoCropWidth="300"
                    :autoCropHeight="200"
                    :canMoveBox="true"
                    :fixed="false"
                    :fixedBox="false"
                    :isCircle="false"
                    :otherData="{
                      format: 'application/pdf',
                      name: 'leave',
                      index: c,
                    }"
                    @getbase64Data="uploadImageNew"
                    v-show="!isGraduate"
                  >
                  </H5Cropper>
                </div>
              </div>
            </div>
            <div
              class="upload-area-add"
              @click="!isGraduate && leavePhotoCount++"
              :style="isGraduate ? 'opacity:0.5' : ''"
            >
              <img src="../assets/images/upload_add.png" /> 增加上传画面
            </div>
          </div>

          <div class="card-style-btn" style="padding-bottom: 12px;">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="next-btn"
              @click="saveCustomerInfo"
              style="width: 100%; margin-left: 0"
            >
              保存并继续
            </van-button>
          </div>
        </div>
        <div class="popup-step popup-step-no">
          <div class="process">
            <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/6.png" />
            <img v-else src="../assets/images/step/f.4.png" />
          </div>
        </div>
      </div>

      <div v-if="noticeStep === 23"></div>

      <div v-if="noticeStep === 24">
        <div
          style="margin: 35% auto auto; text-align: center;"
          class="fadeInDown animated slow"
        >
          <img src="../assets/images/wait.png" style="width: 80%" />
        </div>
        <div
          style="margin-top: 10px; text-align: center;"
          class="fadeInDown animated slow"
        >
          <img src="../assets/images/surprise.png" style="width: 50%" />
        </div>
        <div
          class="complete-result-return fadeInRight animated slow"
          @click="toHome()"
        >
          <img src="../assets/images/reset.png" />
          <img src="../assets/images/repeat.png" />
        </div>
        <div class="complete-result">
          <div
            class="complete-result-item document"
            @click="handleSelectResultPage('document')"
          >
            <div class="line"></div>
            <div class="title">
              创造者档案
              <van-circle
                v-model="currentDocumentRate"
                :rate="documentCompleteRate"
                :speed="500"
                color="#ffffff"
                layer-color="#f9cc81"
                size="50px"
                :stroke-width="130"
                ><div
                  style="vertical-align: middle; color:#f6ede5; height:50px;line-height:50px;"
                >
                  {{ documentRate }}
                </div></van-circle
              >
            </div>
          </div>
          <div
            class="complete-result-item day"
            @click="handleSelectResultPage('day')"
          >
            <div class="line"></div>
            <div class="title">
              距离Day 1还有
              <van-circle
                v-model="daySurplusRate"
                :rate="dayOnJobCompleteRate"
                :speed="500"
                color="#f9cc81"
                layer-color="#ffffff"
                size="50px"
                :stroke-width="130"
                ><div
                  style="vertical-align: middle; color:#f6ede5; height:50px;line-height:50px;"
                >
                  {{ notice.one.day }}
                </div></van-circle
              >
              天
            </div>
          </div>
          <div
            class="complete-result-item file"
            @click="handleSelectResultPage('file')"
          >
            <div class="line"></div>
            <div class="title">
              入职备忘清单
            </div>
          </div>
          <div
            class="complete-result-item question"
            @click="handleSelectResultPage('question')"
          >
            <div class="line"></div>
            <div class="title">
              常见问题小贴士
            </div>
          </div>
        </div>
        <div
          class="complete-result-show fadeInUp animated"
          v-if="resultPageIndex"
          :style="'border-bottom:1px solid ' + sumBorderColor"
        >
          <div
            class="complete-result-show-item document"
            v-if="resultPageIndex === 'document'"
          >
            <div
              class="line fadeInRight animated slow"
              @click="handleSelectResultPage()"
            >
              <div class="line2"></div>
            </div>
            <div class="show-body">
              <van-row style="min-height:130px">
                <van-col span="14">
                  <div class="name">
                    <input
                      type="text"
                      v-model="notice.one.name"
                      style="width: 76%;background: transparent;border: none;height: 36px;line-height: 36px;"
                    />
                    <div
                      class="upload-user-photo-btn"
                      style="width: 24%;font-size: 14px;float: right;margin-top: 5px;"
                      @click="generateCard"
                      v-show="notice.one.name !== notice.one.originName"
                    >
                      保存
                    </div>
                  </div>
                  <div class="dept">入职部门：{{ notice.one.dept }}</div>
                  <div class="age">
                    性别：<span class="sex">{{ notice.one.sex }}</span>
                  </div>
                  <div class="rate">
                    <template v-if="staffType === 'OFFICIAL'">
                      资料完成度：{{ documentCompleteRate }}%
                      <div class="rate-process">
                        <div
                          class="rate-process-item"
                          v-for="(v, key, index) in sumDocumentCompleteRate"
                          :key="index"
                        ></div>
                      </div>
                    </template>
                  </div>
                </van-col>
                <van-col span="10">
                  <div class="user-photo">
                    <div class="user-photo-img">
                      <img
                        :src="uploadCollection.user"
                        v-if="
                          uploadCollection.hasOwnProperty('user') &&
                            uploadCollection.user
                        "
                      />
                    </div>
                  </div>
                  <div
                    class="upload-user-photo-btn"
                    @click="nextNotice(18, 24)"
                  >
                    更改头像
                  </div>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="4">
                  <img src="../assets/images/card.png" />
                </van-col>
                <van-col span="16">
                  个性台卡<br />
                  {{ cardUrl ? "已完成" : "未完成" }}
                </van-col>
                <van-col span="4">
                  <img
                    src="../assets/images/edit.png"
                    @click="nextNotice(30, 24)"
                  />
                </van-col>
              </van-row>
              <van-row v-if="staffType === 'OFFICIAL'">
                <van-col span="4">
                  <img src="../assets/images/card.png" />
                </van-col>
                <van-col span="16">
                  基本信息<br />
                  {{ isComplete ? "已完成" : "未完成" }}
                </van-col>
                <van-col span="4">
                  <img
                    src="../assets/images/edit.png"
                    @click="nextNotice(25)"
                  />
                </van-col>
              </van-row>
              <van-row v-if="staffType === 'OFFICIAL'">
                <van-col span="4">
                  <img src="../assets/images/file.png" />
                </van-col>
                <van-col span="16">
                  有效证件<br />
                  {{ getUploadText("cert") }}
                </van-col>
                <van-col span="4">
                  <img
                    src="../assets/images/edit.png"
                    @click="nextNotice(22)"
                  />
                </van-col>
              </van-row>
              <van-row v-if="staffType === 'OFFICIAL'">
                <van-col span="4">
                  <img src="../assets/images/file.png" />
                </van-col>
                <van-col span="16">
                  学位证<br />
                  {{ getUploadText("edu") }}
                </van-col>
                <van-col span="4">
                  <img
                    src="../assets/images/edit.png"
                    @click="nextNotice(22)"
                  />
                </van-col>
              </van-row>
              <van-row v-if="(onBoardDto.w12 || onBoardDto.w13) && staffType === 'OFFICIAL'">
                <van-col span="4">
                  <img src="../assets/images/file.png" />
                </van-col>
                <van-col span="16">
                  体检报告<br />
                  {{ getUploadText("report") }}
                </van-col>
                <van-col span="4">
                  <img
                    src="../assets/images/edit.png"
                    @click="nextNotice(22)"
                  />
                </van-col>
              </van-row>
              <van-row v-if="staffType === 'OFFICIAL'">
                <van-col span="4">
                  <img src="../assets/images/file.png" />
                </van-col>
                <van-col span="16">
                  离职报告<br />
                  {{ getUploadText("leave") }}
                </van-col>
                <van-col span="4">
                  <img
                    src="../assets/images/edit.png"
                    @click="nextNotice(22)"
                  />
                </van-col>
              </van-row>
            </div>
          </div>

          <div
            class="complete-result-show-item day"
            v-if="resultPageIndex === 'day'"
          >
            <div
              class="line fadeInRight animated slow"
              @click="handleSelectResultPage()"
            >
              <div class="line2"></div>
            </div>
            <div class="show-body">
              <van-row>
                <van-col span="12" style="padding-top: 20px;">
                  <div>距离入职还有{{ notice.one.day }}天！</div>
                  <div>
                    请于{{ notice.one.date }} {{ notice.one.time }}<br />
                    入职{{ notice.one.address }}办公室哦！
                  </div>
                </van-col>
                <van-col span="12">
                  <van-circle
                    v-model="daySurplusRate"
                    :rate="dayOnJobCompleteRate"
                    :speed="500"
                    color="#f9cc81"
                    layer-color="#ffffff"
                    size="120px"
                    :stroke-width="120"
                  >
                    <div
                      style="font-size: 40px;font-weight: bold;height: 25px;line-height: 25px;margin-top: 33px;"
                    >
                      {{ notice.one.day }}<br />
                      <span style="font-size: 20px; font-weight: 400">{{
                        notice.one.day > 1 ? "Days" : "Day"
                      }}</span>
                    </div>
                  </van-circle>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="12" style="padding-top: 20px;">
                  <div>
                    距离参加入职日（Orientation Day）还有{{
                      notice.two.day
                    }}天！
                  </div>
                  <div>
                    请记得于 {{ notice.two.date }}
                    {{ notice.two.time }} 准时到达{{ notice.two.address }}
                  </div>
                </van-col>
                <van-col span="12">
                  <van-circle
                    v-model="daySurplusTrainRate"
                    :rate="dayTrainCompleteRate"
                    :speed="500"
                    color="#f9cc81"
                    layer-color="#ffffff"
                    size="120px"
                    :stroke-width="120"
                  >
                    <div
                      style="font-size: 40px;font-weight: bold;height: 25px;line-height: 25px;margin-top: 33px;"
                    >
                      {{ notice.two.day }}<br />
                      <span style="font-size: 20px; font-weight: 400">{{
                        notice.two.day > 1 ? "Days" : "Day"
                      }}</span>
                    </div>
                  </van-circle>
                </van-col>
              </van-row>
            </div>
          </div>

          <div
            class="complete-result-show-item file"
            v-if="resultPageIndex === 'file'"
          >
            <div
              class="line fadeInRight animated slow"
              @click="handleSelectResultPage()"
            >
              <div class="line2"></div>
            </div>

            <template v-if="staffType === 'INFORMALITY' && userInfo.hireLication && userInfo.orientation">
              <img class="tip_logo" src="../assets/images/wework_white.png" alt="">
            </template>
            <div v-else class="show-body">
              <ul>
                <li class="big-title"><h4>Day 1前：</h4></li>
                <li class="left" v-if="onBoardDto.w12">
                  <span>1</span>
                  ）预约完成入职体检，并上传体检报告。具体信息见入职小贴士第1条；
                </li>
                <li class="left">
                  <span v-if="onBoardDto.w12">2</span>
                  <span v-else>1</span>
                  ）请确保你的​入职资料完成度达​到100%；
                </li>
                <!--li class="left">
                  <span v-if="onBoardDto.w12">3</span>
                  <span v-else>2</span>
                  ）查看你的个人邮箱，你会收到来自Workday系统的入职任务邀请，请激活账号并准确填写相关内容。如有疑问请尽早联系我们；
                </li-->
                <li class="left" v-if="userInfo.isTrain == 'Y'">
                  <span v-if="onBoardDto.w12">3</span>
                  <span v-else>2</span>
                  ）入职日（Orientation
                  Day）需要差旅的创造者们，请尽早预定前往入职日（Orientation
                  Day）城市的交通及住宿，以免耽误行程。具体信息见入职小贴士第3条；
                </li>
                <li class="left">
                  <span v-if="onBoardDto.w12 && userInfo.isTrain == 'Y'">4</span>
                  <span v-else-if="onBoardDto.w12 || userInfo.isTrain == 'Y'">3</span>
                  <span v-else>3</span>
                  ）请通过邮箱/其他联系方式与你的直线经理取得联系，在入职前更多了解你的团队！
                </li>
                <li class="delimiter"></li>
                <li class="delimiter"></li>
                <li class="big-title"><h4>Day 1当天：</h4></li>
                <li class="left" v-if="isGraduate !== 1 && isDalu">
                  <span>1</span>
                  ）请携带你上家雇主离职证明原件（应届生不需要）；
                </li>
                <li class="left" v-if="onBoardDto.w7 && handbook === 'Y'">
                  <span v-if="isGraduate !== 1 && isDalu">2</span>
                  <span v-else>1</span>
                  ） 请携带你的劳动手册 & 退工单；
                </li>
                <li class="left">
                  <span
                    v-if="onBoardDto.w7 && isGraduate !== 1 && isDalu && handbook === 'Y'"
                    >3</span
                  >
                  <span
                    v-else-if="
                      (onBoardDto.w7 && handbook === 'Y') || (isGraduate !== 1 && isDalu)
                    "
                    >2</span
                  >
                  <span v-else>1</span>
                  ）入职培训具体时间地点详见​入职倒计时​和​通知短信。
                </li>
                <li class="delimiter"></li>
                <li class="delimiter"></li>
                <li>
                  *
                  入职资料的上传将会影响到你的入职，请至少提前一周完成上传。WeWork保留对Offer的最终解释权。
                </li>
                <li class="delimiter"></li>
                <li class="delimiter"></li>
                <li>准备Day 1过程中遇到问题？请邮件/电话联系我们吧~</li>
                <li>邮箱：gcpeople@wework.cn</li>
                <li>电话：（021）31755341</li>
              </ul>
            </div>
          </div>

          <div
            class="complete-result-show-item question"
            v-if="resultPageIndex === 'question'"
          >
            <div
              class="line fadeInRight animated slow"
              @click="handleSelectResultPage()"
            >
              <div class="line2"></div>
            </div>
            <template v-if="staffType === 'INFORMALITY' && userInfo.hireLication && userInfo.orientation">
              <img class="tip_logo" src="../assets/images/wework_white.png" alt="">
            </template>
            <div v-else class="show-body">
              <ul>
                <template v-if="onBoardDto.w13">
                  <li class="big-title"><h4>1. 入职体检须知</h4></li>
                  <li class="left">
                    欢迎你即将加入WeWork的大家庭!在此之前，我们推荐你到公司合作的体检机构在各城市的体检中心完成入职体检。​扫描下方二维码注册，预约并完成付款​。​发票（使用Offer上的公司主体抬头，详见后文）将于体检完成后10工作日寄出​，​请注意保留用于入职后报销。
                  </li>
                  <li class="left">
                    <img src="../assets/images/tijian.png" style="width: 70%;" />
                  </li>
                  <li class="delimiter"></li>
                    <li class="left">
                    <span class="big-title" >
                自行体检须知</span><br />
                1. 体检报销 Max 220人民币<br />
                2. 发票抬头必须与Offer劳动主体保持一致<br />
                3. 公立医院二甲及以上或者大型连锁体检机构  </li>
              <li class="delimiter"></li>
                  <li class="left">
                    *
                    距离你入职日期90天内的体检报告都视为有效，可直接上传清晰照片/扫描件，无需再次体检。
                  </li>
                  <li class="delimiter"></li>
                  <li class="left">
                    <span class="big-title"
                      ><span class="dot"></span>公司合作体检中心热线</span
                    ><br />Amy Dong(董丽)：<br />座机 021-8023-1900*871<br />电子邮箱
                    amy.dong@ehnasia.com
                  </li>
                  <li class="delimiter"></li>
                  <li class="big-title left">
                    <span class="dot"></span
                    >体检须知为了更准确地反映你身体的真实情况，请你注意以下内容：
                  </li>
                  <li class="delimiter"></li>
                  <li class="big-title left">饮食原则</li>
                  <li class="left">
                    1）体检前三天应注意饮食均衡，如需做大便潜血检查需素食饮食，避免吃血制品、动物内脏、菠菜等。
                  </li>
                  <li class="left">
                    2）体检前一天清淡饮食、勿饮酒、喝浓茶和咖啡，不要吃对肝、肾功能有损害的药物（降压药、降糖药除外），晚八点后禁食，保证空腹10-12小时抽血检验。
                  </li>
                  <li class="left">
                    3）体检前一天要注意休息，避免过度疲劳，剧烈运动和情绪激动，以免影响体检结果。
                  </li>
                  <li class="left">
                    4）体检的当日晨禁食、禁水；在抽血、腹部彩超、碳13检查后方可进食；如患有糖尿病、冠心病、高血压等慢性疾病，请正常服药（少量水），并告知医生。
                  </li>
                  <li class="left">
                    5）体检当日请着宽松轻便服装，不要穿带金属扣的内衣，不要佩戴首饰，以免影响放射检查；请勿携带贵重物品。
                  </li>
                  <li class="left">
                    6）抽血时间最好在早上8点至9点，最迟不宜超过10点半，以保证检验结果的准确性。
                  </li>
                  <li class="delimiter"></li>
                  <li class="big-title left">女性注意</li>
                  <li class="left">
                    1）怀孕或可能已受孕的女性，请预先告知医护人员，避免进行X光检查。
                  </li>
                  <li class="delimiter"></li>
                  <li class="big-title left">特殊人群</li>
                  <li class="left">
                    1）患有糖尿病、冠心病等慢性病患者，请随身携带常规（急救）药品。
                  </li>
                  <li class="left">
                    2）做餐后2小时血糖者，做完空腹项目后吃二两馒头（从吃第一口计时）2小时后抽血。
                  </li>
                  <li class="left">
                    3）体检时请向医生告知你的不适和曾患疾病，以便注意重点检查，综合分析和评估。
                  </li>
                  <li class="delimiter"></li>
                  <li class="left">
                    体检中心将在体检完成后的一至两个工作日内短信通知领取体检报告。届时请注意查收短信，并按照短信说明查看报告。
                  </li>
                  <li class="delimiter"></li>
                  <li class="delimiter"></li>
                </template>

                <li class="big-title" v-if="onBoardDto.w14">
                  <h4>
                    <span v-if="onBoardDto.w13">2</span>
                    <span v-else>1</span>
                    . 社保公积金转移须知
                  </h4>
                </li>
                <template v-if="onBoardDto.w14">
                  <li class="left">
                    你入职的当月，公司将根据你填写的入职信息表中“入职当月是否需要公司缴纳社保公积金”一栏信息为你支付社会保险和住房公积金（五险一金）。
                  </li>
                  <li class="left">
                    请记得与你的前公司确认社保及公积金缴纳的截止月份。
                    <!--请与你的前公司确认社保及公积金缴纳的截止月份。我们的Payroll团队将据此信息来安排五险一金的缴纳。-->
                  </li>
                </template>
                <li class="left" v-if="onBoardDto.w14">
                  （受雇于上海办公室的员工）您也可以要求前雇主直接将您的社保公积金账号转入以下WeWork公司主体账号
                  <!--你也可以要求前雇主直接将你的社保公积金账号转入以下WeWork公司主体账号-->
                  <span
                    class="small"
                    >（每月10号为当月社保缴纳的截止日）</span
                  >：
                </li>
                <template v-if="onBoardDto.w14">
                  <li class="delimiter"></li>
                  <li class="left">
                    Robinia Commercial Information Consulting (Shanghai) Co.,Ltd
                  </li>
                  <li class="left">洋槐商​务​信息咨​询(上海)有限公司</li>
                  <li class="left">Housing Fund Account 公积金账户</li>
                  <li class="left">885664892205</li>
                  <li class="left">Social Insurance Account 社保账户</li>
                  <li class="left">00957044</li>
                  <li class="delimiter"></li>
                  <li class="left">
                    Red Snapper Co-Work Space Management (Shanghai) Co.,Ltd
                  </li>
                  <li class="left">红鲷众创空间管理(上海)有限公司</li>
                  <li class="left">Housing Fund Account 公积金账户</li>
                  <li class="left">886908744205</li>
                  <li class="left">Social Insurance Account 社保账户</li>
                  <li class="left">01108422</li>
                  <li class="delimiter"></li>
                  <li class="delimiter"></li>
                </template>

                <template v-if="userInfo.isTrain == 'Y' || onBoardDto.w13">
                  <template v-if="userInfo.isTrain == 'Y'">
                    <li class="big-title">
                      <h4>
                        <span v-if="onBoardDto.w13 && onBoardDto.w14">3</span>
                        <span v-else-if="onBoardDto.w13 || onBoardDto.w14"
                          >2</span
                        >
                        <span v-else>1</span>
                        . 入职培训日（Orientation Day）差旅相关信息
                      </h4>
                    </li>
                    <li class="big-title left">A. 差旅交通</li>
                    <li class="left">
                      请尽早自行预定从​（受雇城市）​前往（入职培训日（Orientation
                      Day）城市）​的机票或火车票​（经济舱/一、二等座），并保留​票根​用于入职后报销。由于入职日（Orientation
                      Day）时间开始较早，我们建议你提前一天到达指定城市，返程日期请与你的部门确认后决定​。
                    </li>
                    <li class="delimiter"></li>
                    <li class="big-title left">B. 差旅住宿</li>
                    <li class="left">
                      请尽早自行预定（入职日（Orientation
                      Day）城市）​的住宿酒店，住宿标准如下：
                    </li>
                    <li class="left">
                      <table>
                        <tr>
                          <td>城市</td>
                          <td>住宿标准</td>
                        </tr>
                        <tr>
                                                <td>上海/北京/深圳/广州</td>
                                                    <td>700 RMB/晚</td>
                                                </tr>
                                                <tr>
                                                    <td>二线城市</td>
                                                    <td>500 RMB/晚</td>
                                                </tr>
                                                <tr>
                                                    <td>香港</td>
                                                    <td>700 HKD/晚</td>
                                                </tr>
                                                <tr>
                                                    <td>台北</td>
                                                    <td>2500 NTD/晚</td>
                                                </tr>
                                            </table>
                    </li>
                    <li class="delimiter"></li>
                    <li class="left">
                      我们建议你至少先预定两日住宿并在入职培训日当日与部门确定是否延期​。​请开具发票​（使用Offer上的公司主体抬头，具体信息详见下方贴士）用于入职后报销。
                    </li>
                    <!--li class="delimiter"></li>
                    <li class="left">可以参考以下酒店推荐：</li>
                    <li class="left">上海 -</li>
                    <li class="left">
                      全季酒店上海新天地店（上海、黄浦区、重庆南路283号），​步行约10分钟到达上海HQ
                    </li>
                    <li class="left">
                      锦江都城上海新天地酒店（上海、黄浦区、蒙自路120号），步行约10分钟到达上海HQ
                    </li>
                    <li class="delimiter"></li>
                    <li class="left">北京 -</li>
                    <li class="left">
                      北京丽亭酒店（Park Plaza Beijing
                      Wangfujing），（北京、东城区、金宝街97号)，​步行约13分钟到达北京HQ
                    </li>
                    <li class="left">
                      北京国际艺苑皇冠假日酒店（Crowne Plaza Beijing
                      Wangfujing），（北京、东城区、王府井大街48号），步行约5分钟到达北京HQ
                    </li>
                    <li class="delimiter"></li>
                    <li class="left">其他城市 - 暂不提供</li-->
                                        <li class="delimiter"></li>
                                        <li class="big-title left">C. 差旅餐饮</li>
                                        <li class="left">全国统一标准：CNY 150/天，HKD 200/天，
                                        TWD 1000/天</li>
                                        <!--li class="left">
                                            <table >
                                                <tr>
                                                    <td>城市</td>
                                                    <td>餐饮标准</td>
                                                </tr>
                                                <tr>
                                                    <td>上海/北京</td>
                                                    <td>≤ 360 RMB/天（120 RMB/餐）</td>
                                                </tr>
                                                <tr>
                                                    <td>深圳/广州</td>
                                                    <td>≤ 360 RMB/天（120 RMB/餐）</td>
                                                </tr>
                                                 <tr>
                                                    <td>深圳/广州</td>
                                                    <td>≤ 360 RMB/天（120 RMB/餐）</td>
                                                </tr>
                                                <tr>
                                                    <td>香港</td>
                                                    <td>≤ 450 HKD/天（150HKD/餐）</td>
                                                </tr>
                                                <tr>
                                                    <td>台北</td>
                                                    <td>≤ 1800 NTD/天（600 NTD/餐）</td>
                                                </tr>
                                            </table>
                                        </li-->
                    <li class="left">
                      请保留所有餐饮小票并开具发票（使用Offer上的公司主体抬头，具体信息详见D）用于入职后报销。
                    </li>
                    <li class="delimiter"></li>
                  </template>
                  <li class="big-title left">
                    <span v-if="userInfo.isTrain == 'Y'">D</span><span v-else>
                      <span v-if="onBoardDto.w13">3</span>
                    <span v-else>2</span></span>.
                    公司发票抬头信息
                  </li>
                  <li class="left">洋槐商​务​信息咨​询(上海)有限公司</li>
                  <li class="left">
                    纳​税人​识别​号 Tax Registration Number：91310000MA1K357G20
                  </li>
                  <li class="left">
                    公司地址
                    Address：上海市自由​贸易​​试验​区富特北路215号2​层F​09室
                  </li>
                  <li class="left">公司​电话 ​Phone Number：021-61411404</li>
                  <li class="left">
                    公司开​户​行及​账​号 Bank Name & Account
                    No.：摩根大通​银​行(中国)有限公司上海分行6550039868
                  </li>
                  <li class="delimiter"></li>
                  <li class="left">红鲷​众​创​空​间​管理(上海)有限公司</li>
                  <li class="left">
                    纳​税人​识别​号 Tax Registration Number：91310000MA1FY4H152
                  </li>
                  <li class="left">
                    公司地址 Address：上海市静安区威海路696号10幢1​层
                  </li>
                  <li class="left">公司​电话 ​Phone Number：021-61411404</li>
                  <li class="left">
                    公司开​户​行及​账​号 Bank Name & Account
                    No.：招商银行上海分行营业部 121924236110106
                  </li>
                  <li class="delimiter"></li>
                  <li class="left">威沃克​办​公服​务​(北京)有限公司</li>
                  <li class="left">
                    纳​税人​识别​号 Tax Registration Number：91110105MA018TYG8Y
                  </li>
                  <li class="left">
                    公司地址
                    Address：北京市朝阳区三里屯路11号院3号楼三层​N3-37、四​层​N3-47​单元
                  </li>
                  <li class="left">公司​电话 ​Phone Number：53157240</li>
                  <li class="left">
                    公司开​户​行及​账​号 Bank Name & Account
                    No.：中国工商​银行​股份有限公司北京望京科技园区支行0200296709000190785
                  </li>
                  <li class="delimiter"></li>
                  <li class="left">威沃克商务信息咨询(深圳)有限公司</li>
                  <li class="left">
                    纳​税人​识别​号 Tax Registration Number：91440300MA5EYQL413
                  </li>
                  <li class="left">
                    公司地址
                    Address：深圳市南山区粤海街道后海中心路3331号中建钢构大厦第7层(名义楼层第10层)702-1
                  </li>
                  <li class="left">公司​电话 ​Phone Number：61411404</li>
                  <li class="left">
                    公司开​户​行及​账​号 Bank Name & Account
                    No.：摩根大通银行(中国)有限公司深圳分行6550027236
                  </li>
                  <li class="delimiter"></li>
                  <li class="left">威幄克商务信息咨询（杭州）有限公司</li>
                  <li class="left">
                    纳​税人​识别​号 Tax Registration Number：91330102MA2B1ECB0E
                  </li>
                  <li class="left">
                    公司地址
                    Address：浙江省杭州市上城区延安路292号7层701室
                  </li>
                  <li class="left">公司​电话 ​Phone Number：021-61411404</li>
                  <li class="left">
                    公司开​户​行及​账​号 Bank Name & Account
                    No.：招商银行上海分行营业部121939840910802
                  </li>
                  <li class="delimiter"></li>
                  <li class="left">香港</li>
                  <li class="left">
                    <table>
                      <tr>
                        <td>Invoice Title</td>
                        <td>Address</td>
                      </tr>
                      <tr>
                        <td>WeWork Hong Kong Limited</td>
                        <td>
                          UNIT 417 4/F LIPPO CENTRE TOWER TWO,NO.89 QUEENSWAY
                          ADMIRALTY,HK
                        </td>
                      </tr>
                      <tr>
                        <td>4044 Bonham Strand Tenant Limited</td>
                        <td>
                          UNIT 417 4/F LIPPO CENTRE TOWER TWO,NO.89 QUEENSWAY
                          ADMIRALTY,HK
                        </td>
                      </tr>
                    </table>
                  </li>
                  <li class="delimiter"></li>
                  <li class="left">台湾</li>
                  <li class="left">
                    <table>
                      <tr>
                        <td>Invoice Title</td>
                        <td>台灣威渥客有限公司 Taiwan WeWork Co., Ltd.</td>
                      </tr>
                      <tr>
                        <td>TAX ID</td>
                        <td>030122198</td>
                      </tr>
                      <tr>
                        <td>Address</td>
                        <td>臺北市信義區松仁路101號</td>
                      </tr>
                      <tr>
                        <td>Bank Account</td>
                        <td>滙豐(台灣)商業銀行台北分行001-235191-031</td>
                      </tr>
                      <tr>
                        <td>統一編號</td>
                        <td>82883873</td>
                      </tr>
                    </table>
                  </li>
                  <li class="delimiter"></li>
                </template>

                <template
                  v-if="
                    !onBoardDto.w13 &&
                      onBoardDto.w14 &&
                      userInfo.isTrain == 'Y' &&
                      onBoardDto.w13
                  "
                >
                  <li class="left"></li>
                  <li class="left">
                    <img src="../assets/images/wework_white.png" />
                  </li>
                  <li class="left">
                    如果你还有其他入职问题，请邮件联系我们：gcpeople@wework.cn
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <template v-if="noticeStep === 25">
        <perfect-info-dialog @perfect-done="handlePerfectDone" />
      </template>

      <div v-if="noticeStep === 26"></div>

      <div v-if="noticeStep === 27"></div>

      <div v-if="noticeStep === 28"></div>

      <div v-if="noticeStep === 30">
        <div class="card-page-step">
          <div class="select-style-diy card-tips">
            长按图片保存你的台卡！
          </div>
          <div class="card-style-body-result">
            <img :src="cardUrl" v-if="cardUrl" />
          </div>
          <div class="card-style-btn" style="width: 100%;" v-show="cardUrlBtn">
            <van-button
              slot="button"
              size="small"
              type="default"
              class="prev-btn"
              @click="nextNotice(17)"
              style="width: 60%"
            >
              返回修改
            </van-button>
            <br />
            <van-button
              slot="button"
              size="small"
              type="default"
              class="next-btn"
              @click="saveCardResult"
              style="width: 60%; margin-left:0"
            >
              继续
            </van-button>
          </div>
        </div>
        <div class="popup-step">
          <div class="process">
            <img v-if="staffType === 'OFFICIAL'" src="../assets/images/step/5.png" />
            <img v-else src="../assets/images/step/f.4.png" />
          </div>
        </div>
      </div>

      <div class="popup-light" v-if="popupLightImg">
        <div class="popup-light-close" @click="closePopupLight">
          <img src="../assets/images/close.png" />
        </div>
        <div class="popip-light-img">
          <van-image :src="popupLightImg" @click="handlePopupLight"></van-image>
        </div>
      </div>
    </div>

    <div class="video" v-if="videoKey">
      <div class="popup-light-close" @click="closeVideo">
        <img src="../assets/images/close.png" />
      </div>
      <div v-if="videoKey === 'introduction'">
        <iframe
          id="introduction-video"
          style="position:absolute; top:35%"
          height="240"
          width="100%"
          src="https://player.youku.com/embed/XNDEzMDI3NTIzMg=="
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
      <div v-else>
        <video
          controls="controls"
          autoplay="autoplay"
          width="100%"
          height="100%"
          id="video"
          style="position: absolute"
          muted="muted"
        >
          <source :src="video[videoKey]" type="video/mp4" />
        </video>
      </div>
    </div>

    <div class="show-city" v-if="isShowCity && city[cityName]">
      <img
        class="left-arrow"
        src="../assets/images/city/left.png"
        @click="changeCityImage('left')"
      />
      <div class="show-city-center">
        <div
          class="show-city-img"
          v-if="city[cityName].images && city[cityName].images.length"
        >
          <van-swipe
            class="my-swipe"
            :show-indicators="false"
            :width="300"
            :height="280"
            ref="citySwipe"
            @change="changeCityImageSwipe"
          >
            <van-swipe-item
              v-for="(img, index) in city[cityName].images"
              :key="index"
            >
              <img :src="img" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="show-city-text">
          <div class="title">{{ city[cityName].title }}</div>
          <div>{{ city[cityName].address }}</div>
          <div>
            {{ city[cityName].desc }}
          </div>
        </div>
      </div>
      <img
        class="right-arrow"
        src="../assets/images/city/right.png"
        @click="changeCityImage('right')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import PerfectInfoDialog from "../components/perfectInfoDialog";
import {
  Row,
  Col,
  Field,
  Image,
  Toast,
  Popup,
  Button,
  CellGroup,
  Uploader,
  Circle,
  Icon,
  Swipe,
  SwipeItem,
} from "vant";

import H5Cropper from "../components/cropper";
import { baseInfoIsDone, getOffice } from "../utils";

export default {
  name: "Introduce",
  components: {
    PerfectInfoDialog,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Image.name]: Image,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Uploader.name]: Uploader,
    [Circle.name]: Circle,
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    H5Cropper,
  },
  data() {
    return {
      option: {
        fixed: false,
        fixedBox: false,
        canMoveBox: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
      },
      videoKey: "",
      video: {
        light: null,
      },
      popupLightImg: null,
      popupLightImgCache: {},
      showCover: false,
      showPowerCover: false,
      bgImageClass: "welcome-page",
      showNotice: true,
      noticeStep: 1,
      prevStep: 0,
      peopleName: {
        one: "Diane",
        two: "William",
        three: "Bob",
      },
      notice: {
        one: {
          name: "",
          originName: "",
          peopleName: "",
          date: "",
          address: "",
          dept: "",
          age: 26,
          sex: "女",
          day: 0,
        },
        two: {
          date: "",
          address: "",
          day: 0,
        },
        three: {
          manager: "",
          email: "",
        },
        hr: {
          email: "gcpeople@wework.cn",
        },
      },
      people: "one",
      peopleImage: {
        one: require("../assets/images/one_select.png"),
        two: require("../assets/images/two_select.png"),
        three: require("../assets/images/three_select.png"),
      },
      allPeopleImage: {},
      isLeftPeople: true,
      leftPeople: "",
      rightPeople: "",
      isRightPeople: false,
      isRightPeopleHr: false,
      hrPeople: require("../assets/images/hr.png"),
      videoImage: require("../assets/images/video_bg.jpg"),
      templateStyle: "card1",
      userTag: [
        [
          {
            name: "Traveler",
            img: require("../assets/images/icon/Traveler.png"),
            selected: false,
          },
          {
            name: "DogPerson",
            img: require("../assets/images/icon/DogPerson.png"),
            selected: false,
          },
        ],
        [
          {
            name: "Foodie",
            img: require("../assets/images/icon/Foodie.png"),
            selected: false,
          },
          {
            name: "PetLover",
            img: require("../assets/images/icon/PetLover.png"),
            selected: false,
          },
        ],
        [
          {
            name: "Peace&Love",
            img: require("../assets/images/icon/Peace&Love.png"),
            selected: false,
          },
          {
            name: "Gym",
            img: require("../assets/images/icon/Gym.png"),
            selected: false,
          },
        ],
        [
          {
            name: "Photography",
            img: require("../assets/images/icon/Photography.png"),
            selected: false,
          },
          {
            name: "TravelLover",
            img: require("../assets/images/icon/TravelLover.png"),
            selected: false,
          },
        ],
        [
          {
            name: "Coffeeholic",
            img: require("../assets/images/icon/Coffeeholic.png"),
            selected: false,
          },
          {
            name: "Optimist",
            img: require("../assets/images/icon/Optimist.png"),
            selected: false,
          },
        ],
        [
          {
            name: "Basketball",
            img: require("../assets/images/icon/Basketball.png"),
            selected: false,
          },
          {
            name: "MovieFan",
            img: require("../assets/images/icon/MovieFan.png"),
            selected: false,
          },
        ],
        [
          {
            name: "Learner",
            img: require("../assets/images/icon/Learner.png"),
            selected: false,
          },
          {
            name: "FashionLover",
            img: require("../assets/images/icon/FashionLover.png"),
            selected: false,
          },
        ],
        [
          {
            name: "Creative",
            img: require("../assets/images/icon/Creative.png"),
            selected: false,
          },
          {
            name: "Family",
            img: require("../assets/images/icon/Family.png"),
            selected: false,
          },
        ],
        [
          {
            name: "自定义",
            selected: false,
            edit: false,
            customer: true
          },
          {
            name: "自定义",
            selected: false,
            edit: false,
            customer: true
          },
        ],
        [
          {
            name: "自定义",
            selected: false,
            edit: false,
            customer: true
          },
        ],
      ],
      customize_tag: "##,##,##",
      selectUserTag: {},
      peopleDeclaration: "",
      loveMusic: {
        one: "",
        two: "",
      },
      enRegular: /^(?!_)([A-Za-z0-9\.\?\"\'\!\,\-\(\)\[\]\;\:\#\&\s\/ ]+)$/,
      enAndCnRegular: /^(?!_)([\u0391-\uFFE5A-Za-z0-9\.\?\"\'\!\,\-\(\)\[\]\;\:\#\&\s\/ ]+)$/,
      showReport: false,
      certPhotoCount: 1,
      eduPhotoCount: 1,
      reportPhotoCount: 1,
      leavePhotoCount: 1,
      uploadCollection: {
        user: "",
        cert: {},
        edu: {},
        report: {},
        leave: {},
      },
      serverCollection: {
        user: "",
        cert: {},
        edu: {},
        report: {},
        leave: {},
      },
      currentDocumentRate: 0,
      documentCompleteRate: 50,
      daySurplusRate: 0,
      dayOnJobCompleteRate: 0,
      daySurplusTrainRate: 0,
      dayTrainCompleteRate: 0,
      resultPageIndex: "",
      originalHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      showFooterStep: true,
      //服务端生成的台卡
      cardUrl: "",
      cardUrlBtn: false,
      isGraduate: false,
      isShowCity: false,
      cityName: "",
      cityImageIndex: 0,
      city: {
        sh001: { // TODO 替换成深圳
          style: "",
          title: "深圳",
          address: "CCSS中建钢构",
          desc: "地处大企业总部云集的后海，CCSS整体装修风格通透明亮，3层的办公空间采用了大量绿植和鲜艳色彩加以点缀，营造出都市园林的空间感，让办公体验更加舒适温馨。很大的落地窗，能够一览城市之窗的风采！",
          images: [
            require("../assets/images/city/sh001-001.jpg"),
            require("../assets/images/city/sh001-002.jpg"),
          ],
        },
        sh002: {
          style: "",
          title: "上海",
          address: "威海路696号",
          desc:
            "这栋伦敦风格别墅建于20世纪初，曾有40余个艺术工作室和展览厅在此。如今，WeWork将其改造成为古典与现代相结合的优美工作场所：明亮宽敞的开放式中庭、别具一格的旋转楼梯，成为公认的中国旗舰社区。",
          images: [
            require("../assets/images/city/sh002-001.jpg"),
            require("../assets/images/city/sh002-002.jpg"),
            require("../assets/images/city/sh002-003.jpg"),
          ],
        },
        bj001: {
          style: "",
          title: "北京",
          address: "北京坊",
          desc:
            "在老北京中心地段，从商贾云集的大栅栏到全新文化地标的北京坊，WeWork以人性化的设计重新赋予这幢百年建筑新的使命。",
          images: [
            require("../assets/images/city/bj001-001.jpg"),
            require("../assets/images/city/bj001-002.jpg"),
          ],
        },
        bj002: { // TODO 替换南京
          style: "",
          title: "南京",
          address: "金鹰国际中心社区",
          desc: "是南京三个WeWork社区之一，位于南京市新街口核心地段，见证了南京近20年来的变迁和发展。我们仅对楼层进行了功能性改造，最大程度的保留其原始结",
          images: [
            require("../assets/images/city/bj002-001.jpg"),
            require("../assets/images/city/bj002-002.jpg"),
          ],
        },
        sz001: { // TODO 替换成香港
          style: "",
          title: "香港",
          address: "Two Harbour Square",
          desc:
            "座落位于东九新贵观塘区，进驻甲级商厦的最顶两层，更坐拥九龙湾及启德邮轮码头海景 。此空间占地58,000平方尺，会员更可独家专享海景露台及3,200平方尺的空中花园，开放举办各种规模的活动。",
          images: [
            require("../assets/images/city/sz001-001.jpg"),
            require("../assets/images/city/sz001-002.jpg"),
          ],
        },
      },
      //地区对象
      onBoardDto: {},
      //最后提交时间
      entrySureTimeDate: "",
      //劳动手册
      handbook: "",
      //离职
      leaving: "",
      //pdf图像
      showPdfData: require("../assets/images/pdf.png"),
    };
  },
  computed: {
    ...mapGetters(["getBusinessData", "getUserInfo"]),
    cardName() {
      const index = this.templateStyle ? parseInt(this.templateStyle.substring(4)) : 1;
      const cardNameMap = {
        1: '上海威海路696号',
        2: '北京坊',
        3: '墙面插画1',
        4: '墙面插画2',
        5: '墙面插画3',
        6: '墙面插画4',
        7: '香港Tower 535',
        8: '墙面插画5',
        9: '成都领地中心',
        10: '墙面插画6',
      }
      return cardNameMap[index];
    },
    userInfo() {
      return this.getUserInfo()
    },
    documentRate() {
      return this.currentDocumentRate.toFixed(0) + "%";
    },
    sumDocumentCompleteRate() {
      return Math.floor(this.documentCompleteRate / 20);
    },
    sumBorderColor() {
      switch (this.resultPageIndex) {
        case "document":
          return "#f16043";
        case "day":
          return "#f39a02";
        case "file":
          return "#1687af";
        case "question":
          return "#19a18d";
      }

      return "transparent";
    },
    staffType() { // 员工类型
      // OFFICIAL INFORMALITY
      let userInfo = this.getUserInfo();

      if (['正式员工', '返聘员工'].includes(userInfo.employeeType)) {
        return 'OFFICIAL'
      }

      return 'INFORMALITY'
    },
    isDalu() { // 是否是大陆办公室
      let userInfo = this.getUserInfo();
      return getOffice(userInfo.hireLication) === '中国大陆';
    }
  },
  watch: {
    noticeStep(nv, ov) {
      if (+nv === 24) {
        this.renderCustomerInfo();
      }

      let userInfo = this.getUserInfo();
      console.log(nv);

      // 1. 初识WeWork
      if (nv === 8) {
        this.upStep(1)
      }
      // 2. 了解4个价值观
      if (nv === 11) {
        this.upStep(2)
      }
      //3. 探索我们的空间
      if (nv === 14) {
        this.upStep(3)
      }
      //4. 发现员工福利
      if (nv === 16) {
        if (this.staffType === "OFFICIAL") {
          this.upStep(4)
        }
      }
      //5. 定制你的个性“台卡”
      if (nv === 30) {
        if (this.staffType === "OFFICIAL") {
          this.upStep(5)
        } else {
          this.upStep(4)
        }
      }
      //6. 上传入职材料
      if (nv === 29) {
        if (this.staffType === "OFFICIAL") {
          this.upStep(6)
        }
      }
    },
  },
  methods: {
    ...mapMutations(["setBusinessData"]),
    handlePerfectDone() {
      this.jumpStep(22);
    },
    /**
     *  上报完成步骤
     */
    upStep(step) {
      let userInfo = this.getUserInfo();
      let uStep = userInfo.step || 0;
      if (this.staffType !== "OFFICIAL") {
        uStep = uStep > 4 ? 4 : uStep
      }
      console.log('step :>> ', step);
      console.log('uStep :>> ', uStep);
      console.log('是否上传 :>> ', step >= (uStep - 0));
      if (uStep && step < (uStep - 0)) {
        return;
      }
      this.$api.doPost("/customer/editCustomer", { step });
    },
    handleEdit(tag) {
      tag.name = ''
      tag.edit = true
    },
    handleTagInputBlur(tag) {
      if (!tag.name) {
        tag.name = '自定义'
      }
      tag.edit = false
    },
    getStepContent(index) {
      switch (index) {
        case 1:
          return `${this.notice.one.name}你好，我叫${this.notice.one.peopleName}，欢迎加入WeWork！很荣幸由我带你参观公司！你的入职日期是<span
          class="text-hi">${this.notice.one.date}</span>，入职地点是<span
          class="text-hi">${this.notice.one.address}</span>。`;
        case 2:
          return `在WeWork，我们用精心安排的入职培训日「Hello Creator」来迎接每一位新伙伴。顺便告诉你，你的入职培训日地点将会在<span
          class="text-hi">${this.notice.two.address}</span>，时间是<span
          class="text-hi">${this.notice.two.date}</span>。详细信息会在最后有更多说明哦。`;
        case 3:
          return `除此之外，入职前与你的直线经理<span
          class="text-hi">${this.notice.three.manager}</span>取得联系，有助于你更早地了解工作内容和团队！你经理的邮箱是：<span
          class="text-hi">${this.notice.three.email}</span>。`;
        case 4:
          if (this.staffType === 'INFORMALITY') {
            return `不客气！现在请拿出10分钟左右时间完成入职之旅的下面几步吧！在<span
            class="text-hi">${this.entrySureTimeDate}</span>前都可以完成和修改哦：<br />1. 初识WeWork<br />2. 了解4个价值观<br />3. 探索我们的空间<br />4. 定制你的个性名片<br />`;
          }
            return `不客气！现在请拿出10分钟左右时间完成入职之旅的下面几步吧！在<span
            class="text-hi">${this.entrySureTimeDate}</span>前都可以完成和修改哦：<br />1. 初识WeWork<br />2. 了解4个价值观<br />3. 探索我们的空间<br />4. 发现员工福利<br />5. 定制你的个性名片<br />6. 完成入职信息及材料上传`;
        case 5:
          return "2010年WeWork在纽约创立，是全球领先的办公空间服务平台。截止至2020年第三季度，WeWork已建立了859个社区，覆盖38个国家共151个城市，拥有54万名会籍。我们的使命是：通过精心设计的空间（space)，灵活性(flexibility)，科技 (Technology) 和社区(Community) 重塑人们的工作方式。 ";
        case 6:
          return "或许这个视频可以更好地带你了解我们Creator的起源和文化！";
        case 8:
          return "相信你已经对WeWork有了初步认识！现在我们来到了公共休闲区（Common Area），你可以选择在这里吃饭、放松、与同事交流，还有咖啡、茶和清爽健康的水果水可以选择！";
        case 9:
          return "WeWork大家庭有4个重要的价值观，帮助我们始终保持活力和成长。来探索一下吧！";
        case 11:
          return "自2016年WeWork进入中国以来，已经在上海、香港、北京、广州、深圳、杭州、苏州、南京、武汉、成都、西安、台北建立约100个社区，是一家兼具全球品牌优势及战略资源的中国企业，更高效、更扎实、更贴近中国市场需求，协同中国本土合作伙伴，继续致力引领中国未来的灵活办公方式。我们通过独特的办公空间、体验和生态提升企业雇员的效率和福祉，赋能“人才推动型”成长企业共同成长。";
        case 12:
          return "如果有时间，可以逛逛你所在城市的WeWork社区，会发现每一处空间都有它们自己的故事！还可以找出你最爱的一角合影，放在名片里入职分享给新同事噢！";
        case 13:
          return "这里是办公区！WeWork的办公区分为开放区域的工位，和私密性较好的专属办公室。这里的灯光、背景音乐和设施布局都经过精心设计，加上齐全的办公设备，让工作在里面的人们心情舒畅，效率爆表！";
        case 14:
          return "WeWork的魅力可不止这些！<br />这里还有很多员工福利等着你去探索呢！";
        case 16:
          return "现在可以开始制作你的个性台卡啦！<br />WeWork所有小伙伴都将在你入职第一天看到这张名片，介绍下你自己的经历和爱好，给他们留下一个深刻的第一印象吧！";
        case 21:
          if (this.staffType === 'INFORMALITY') {
            return "你的个性台卡已经生成啦！入职当天一定惊艳全场！";
          }
          return "你的个性台卡已经生成啦！入职当天一定惊艳全场！如果你还不够满意，还可以在后面的“入职简介”里继续完善哦！现在我们可以进行最后一步 --- 提交入职材料！";
        case 36:
          return "我们的社区是属于所有创造者（Creators）的社区，包括每一个员工。我们希望每个人在WeWork的空间，都能从事自己热爱的工作（Do What You Love），在此过程中，他们能从社区获得所需的资源和力量。";
        case 40:
          return "要了解更多的We空间信息，记得登录<br />https://www.wework.cn<br />切换城市查看哦～";
      }
    },
    loadPeopleImage(direction, index) {
      let key = this.people + "_" + index;
      if (!this.allPeopleImage.hasOwnProperty(key)) {
        this.allPeopleImage[key] = require("../assets/images/people/" +
          key +
          ".png");
      }

      this.isLeftPeople = false;
      this.isRightPeople = false;
      if (direction === "left") {
        this.isLeftPeople = true;
        this.leftPeople = this.allPeopleImage[key];
      } else {
        this.isRightPeople = true;
        this.rightPeople = this.allPeopleImage[key];
      }
    },
    nextNotice(index, prevPage = 0) {
      if (event) {
        event.preventDefault();
      }

      if ([18,19,20,35].includes(index)) {
        this.updateCardInfo();
      }

      if (index === 19) {
        if (!this.uploadCollection.hasOwnProperty("user")) {
          Toast.fail("请上传个人照片！");
          return false;
        } else {
          //this.saveData('uploadCollection.user', this.uploadCollection.user);
        }
      }

      if (index === 20) {
        if (this.customize_tag && !this.enRegular.test(this.customize_tag)) {
          Toast.fail("自定义标签请输入英文！");
          return false;
        }

        this.saveData("selectUserTag", this.selectUserTag);
        this.saveData("customize_tag", this.customize_tag);
      }

      if (index === 29) {
        if (!this.uploadCollection.hasOwnProperty("cert")) {
          // Toast.fail('身份证或护照必须上传!');
          // return false;
        } else {
          //this.saveData('uploadCollection.cert', this.uploadCollection.cert);
        }

        if (!this.uploadCollection.hasOwnProperty("edu")) {
          // Toast.fail('学位证书必须上传!');
          // return false;
        } else {
          //this.saveData('uploadCollection.edu', this.uploadCollection.edu);
        }
      }

      if (index === 30) {
        if (!this.loveMusic.one || !this.loveMusic.two) {
          // Toast.fail('请填与最爱的两首歌！');
          // return false;
        } else {
          this.saveData("loveMusic.one", this.loveMusic.one);
          this.saveData("loveMusic.two", this.loveMusic.two);
        }

        this.generateCard();

      }

      if (index === 35) {
        // if (!this.enAndCnRegular.test(this.peopleDeclaration)) {
        //     Toast.fail('个人宣言请输入英文和中文！');
        //     return false;
        // }

        let declarationLen = this.peopleDeclaration.length;
        // for (let i = 0; i < this.peopleDeclaration.length; i++) {
        //     let charCode = this.peopleDeclaration.charCodeAt(i);
        //     if (charCode >= 0 && charCode <= 128) {
        //         declarationLen++;
        //     } else {
        //         declarationLen += 2;
        //     }
        // }
        if (declarationLen > 200) {
          Toast.fail("个人宣言只能输入200个字符！");
          return false;
        }

        this.saveData("peopleDeclaration", this.peopleDeclaration);
      }

      this.noticeStep = index;
      if (prevPage > 0) {
        this.prevStep = prevPage;
      }
      this.bgImageClass = "welcome-page";
      this.showNotice = true;
      this.isLeftPeople = true;
      this.isRightPeopleHr = false;
      this.showCover = false;
      this.showPowerCover = false;
      this.resultPageIndex = "";

      if (index > 1 && index < 4) {
        this.bgImageClass = "page";
      }

      if ((index > 3 && index < 6) || index === 36) {
        this.bgImageClass = "line-page";
      }

      if (index === 6) {
        this.bgImageClass = "people-video-page";
      }

      if (index === 7) {
        this.bgImageClass = "video-page";
        this.isLeftPeople = false;
        this.isRightPeople = false;
        this.showNotice = false;
      }

      if (index > 7 && index <= 12) {
        this.bgImageClass = "right-page";
        this.isLeftPeople = false;
        this.isRightPeople = false;
      }

      if (index > 9) {
        this.isLeftPeople = false;
        this.isRightPeople = true;
      }

      if (index === 10) {
        this.showNotice = false;
        this.isLeftPeople = false;
        this.isRightPeople = false;
        this.bgImageClass = "right-page";
      }

      if (index > 10) {
        this.isRightPeople = true;
      }

      if (index === 13 || index === 14 || index === 16) {
        this.bgImageClass = "office-page";
      }

      if (index === 15) {
        this.showNotice = false;
        this.isLeftPeople = false;
        this.isRightPeople = false;
        this.bgImageClass = "office-page";
      }

      if (index === 16) {
        this.isLeftPeople = true;
        this.isRightPeople = false;
      }

      if (index > 16 && index < 21) {
        this.isLeftPeople = false;
        this.isRightPeople = false;
        this.showNotice = false;
        this.bgImageClass = "card-page";
        this.showCover = true;
      }

      if (index === 21) {
        this.showCover = false;
        this.isLeftPeople = true;
        this.isRightPeople = false;
        this.bgImageClass = "office-page";
      }

      if (index === 24) {
        this.bgImageClass = "complete-page";
      }

      if (index > 21 && index < 29) {
        this.showCover = false;
        this.isLeftPeople = false;
        this.isRightPeople = false;
        this.showNotice = false;
      }

      if (index === 22) {
        this.showCover = true;
        this.bgImageClass = "office-page";
      }

      if (index === 29) {
        this.showNotice = true;
        this.isLeftPeople = false;
        this.isRightPeople = false;
        this.bgImageClass = "hr-page";
        this.isRightPeopleHr = true;
      }

      if (index === 30 || index === 35) {
        this.showCover = index === 35;
        this.showNotice = false;
        this.isLeftPeople = false;
        this.isRightPeople = false;
        this.bgImageClass = "card-page";
      }

      if (index === 40) {
        this.bgImageClass = "city-page";
        if (this.people === "two") {
          this.loadPeopleImage("right", 5);
        } else {
          this.loadPeopleImage("right", 6);
        }
      }

      //插画
      switch (index) {
        case 1:
          this.loadPeopleImage("left", 5);
          break;
        case 2:
          this.loadPeopleImage("left", 0);
          break;
        case 3:
          this.loadPeopleImage("left", 3);
          break;
        case 4:
          this.loadPeopleImage("left", 2);
          break;
        case 5:
        case 6:
        case 36:
          this.loadPeopleImage("left", 4);
          break;
        case 8:
          this.loadPeopleImage("left", 0);
          break;
        case 9:
          this.loadPeopleImage("left", 2);
          break;
        case 11:
          this.loadPeopleImage("right", 3);
          break;
        case 12:
          this.loadPeopleImage("right", 6);
          break;
        case 13:
          this.loadPeopleImage("right", 4);
          break;
        case 14:
          this.loadPeopleImage("right", 6);
          break;
        case 16:
          this.loadPeopleImage("left", 2);
          break;
        case 21:
          this.loadPeopleImage("right", 2);
          break;
      }
    },
    showLight(index) {
      this.showCover = true;

      let key = "light_" + index;
      if (!this.popupLightImgCache.hasOwnProperty(key)) {
        this.popupLightImgCache[key] = require("../assets/images/light_" +
          index +
          ".png");
      }
      this.popupLightImg = this.popupLightImgCache[key];
    },
    closePopupLight() {
      this.showCover = false;
      this.popupLightImg = null;
    },
    handleSelectCard(card) {
      this.templateStyle = card;
      this.saveData("templateStyle", card);
      // this.nextNotice(18);
    },
    handleSelectTag(tag) {
      let selected = !tag.selected;
      if (selected && !this.isMaxThreeTag()) {
        return false;
      }

      tag.selected = selected;
      if (tag.selected) {
        this.selectUserTag[tag.name] = tag;
      } else if (this.selectUserTag.hasOwnProperty(tag.name)) {
        delete this.selectUserTag[tag.name];
      }

      let tagArr = [];
      if (Object.keys(this.selectUserTag).length > 0) {
        for (let k in this.selectUserTag) {
          tagArr.push("#" + k + "#");
        }
      }

      if (tagArr.length < 3) {
        //抽取自定义
        let yt = [];
        let ct = this.customize_tag.split(",");
        ct.forEach((v) => {
          let fl = true;
          for (let i = 0; i < this.userTag.length; i++) {
            for (let k = 0; k < this.userTag[i].length; k++) {
              if ("#" + this.userTag[i][k].name + "#" === v) {
                fl = false;
                break;
              }
            }
          }
          if (fl && v !== "##") {
            yt.push(v);
          }
        });
        tagArr = tagArr.concat(yt);

        for (let i = tagArr.length; i < 3; i++) {
          tagArr.push("##");
        }
      }

      this.customize_tag = tagArr.join(",");

      if (tagArr.length == 3) {
        this.updateTag()
      }
    },
    isMaxThreeTag() {
      let selectTagLen = Object.keys(this.selectUserTag).length;
      if (selectTagLen >= 3) {
        Toast.fail("不能超过3个标签！");
        return false;
      }
      return true;
    },
    getTemplateStyleImg() {
      return require("../assets/images/" + this.templateStyle + ".png");
    },
    //覆盖返回按钮功能
    handlePrev() {
      //优先处理特殊的转场
      if (this.prevStep > 0) {
        let step = this.prevStep;
        this.prevStep = 0;
        this.nextNotice(step);
        return false;
      }

      if (this.noticeStep === 7) {
        this.nextNotice(1);
      } else if (this.noticeStep > 7 && this.noticeStep <= 12) {
        this.nextNotice(7);
      } else if (this.noticeStep > 12 && this.noticeStep <= 16) {
        this.nextNotice(8);
      } else if (
        (this.noticeStep > 16 && this.noticeStep <= 20) ||
        this.noticeStep === 30 ||
        this.noticeStep === 35
      ) {
        this.nextNotice(13);
      } else if (this.noticeStep === 21) {
        this.nextNotice(17);
      } else if (this.noticeStep === 22) {
        this.nextNotice(21);
      } else if (this.noticeStep === 23) {
        this.nextNotice(29);
      } else if (this.noticeStep === 24) {
        this.nextNotice(29);
      } else if (this.noticeStep === 29) {
        if (this.staffType === "OFFICIAL") {
          this.nextNotice(22);
        } else {
          this.nextNotice(21);
        }
      } else {
        this.toGuide();
      }
    },
    toGuide() {
      this.$router.push("/guide");
    },
    toHome() {
      this.$router.push("/home?page=introduce&step=24");
    },
    handlePopupLight(e) {
      e.preventDefault();

      // if (this.popupLightImg.indexOf('light_12') > -1) {
      //     let videoKey = 'light';
      //     if (!this.video[videoKey]) {
      //         this.video[videoKey] = require('../assets/video/1084ff2b51ff4a80a20da4e4fc96054a.mp4');
      //     }
      //
      //     this.videoKey = videoKey;
      //     this.$emit('audioPlay', false);
      //
      //     this.$nextTick(() => {
      //         this.closePopupLight();
      //         let video = document.getElementById('video');
      //         video.addEventListener('ended', () => {
      //             this.videoKey = '';
      //             this.$emit('audioPlay', true);
      //         }, false);
      //     });
      // }
    },
    handleIntroductionVideo(e) {
      e.preventDefault();

      //优酷
      /* let videoKey = 'introduction'; */

      let videoKey = "local_introduction";
      if (!this.video[videoKey]) {
        /* this.video[videoKey] = 'https://v.youku.com/v_show/id_XNDEzMDI3NTIzMg==.html?spm=a2hzp.8244740.0.0'; */
        this.video[
          videoKey
        ] = require("../assets/video/What_is_W_Work_Final.mp4");
      }

      this.videoKey = videoKey;
      this.$emit("audioPlay", false);

      this.$nextTick(() => {
        let video = document.getElementById("video");
        if (video) {
          video.addEventListener(
            "ended",
            () => {
              this.videoKey = "";
              this.$emit("audioPlay", false);
            },
            false
          );
        }
      });
    },
    closeVideo(e) {
      e.preventDefault();
      this.videoKey = "";
      this.$emit("audioPlay", false);
    },
    realUploadImageServer(key, file, index = 0, resolve = null, reject = null) {
      let fileHeader = file.substring(0, 18);
      let fileHeaderArr = fileHeader.split(";");
      let suffix = "jpg";
      if (fileHeaderArr.length > 0) {
        let formatArr = fileHeaderArr[0].split("/");
        if (formatArr.length > 0) {
          suffix = formatArr[1];
        }
      }

      let params = {
        imgstr: file,
        ext: "." + suffix,
      };
      this.$api.doPost("/common/uploadFileBase", params).then((res) => {
        this.serverCollection[key] = res.path;
        this.saveData("serverCollection." + key, res.path);
        this.$forceUpdate();
        if (typeof resolve === "function") {
          resolve(res);
        }
      });
    },
    uploadImageNew(urlData, otherData) {
      let key = otherData.name;
      let index = otherData.index;
      let method = "uploadFileBase";
      let header = {};
      let params = {};
      let showData = "";
      if (typeof urlData !== "string" && urlData.type.indexOf("pdf") > -1) {
        showData = this.showPdfData;
        method = "uploadFile";
        header = {
          "Content-Type": "multipart/form-data",
        };

        params = new FormData();
        params.append("file", urlData);
        params.append("ext", ".pdf");
      } else {
        let fileHeader = urlData.substring(0, 18);
        let fileHeaderArr = fileHeader.split(";");
        let suffix = "jpg";
        if (fileHeaderArr.length > 0) {
          let formatArr = fileHeaderArr[0].split("/");
          if (formatArr.length > 0) {
            suffix = formatArr[1];
          }
        }
        showData = urlData;
        params.imgstr = urlData;
        params.ext = "." + suffix;
      }

      this.$api.doPost("/common/" + method, params, header).then((res) => {
        if (index > 0) {
          this.uploadCollection[key][index] = showData;
          //this.saveData('uploadCollection.' + key + '.' + index, showData);

          this.serverCollection[key][index] = res.path;
          //this.saveData('serverCollection.' + key + '.' + index, res.path);
        } else {
          this.uploadCollection[key] = showData;
          //this.saveData('uploadCollection.' + key, showData);

          this.serverCollection[key] = res.path;
          //this.saveData('serverCollection.' + key, res.path);
        }

        this.$forceUpdate();
      });
    },
    uploadImage: function(key, file, index = 0) {
      this.clip(event, {
        resultObj: null,
        aspectRatio: 1,
        uploadAfter: (file) => {
          if ("cert" === key) {
            this.uploadCollection.cert[index] = file;
          } else {
            this.uploadCollection[key] = file;
          }
          this.realUploadImageServer(key, file);
        },
        cancelAfter: (file, originUrl) => {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (e) => {
            if ("cert" === key) {
              this.uploadCollection.cert[index] = e.target.result;
            } else {
              this.uploadCollection[key] = e.target.result;
            }
            this.realUploadImageServer(key, e.target.result);
          };
        },
      });
    },
    closeImage(key, index = 0) {
      if (index > 0) {
        // if (Object.keys(this.uploadCollection[key]).length === 1) {
        //     Toast.fail('不能全部删除！');
        //     return false;
        // }
        this.uploadCollection[key][index] = "";
        this.serverCollection[key][index] = "";
        //this.saveData('uploadCollection.' + key + '.' + index, '');
        //this.saveData('serverCollection.' + key + '.' + index, '');

        let len = Object.keys(this.uploadCollection[key]).length;
        if (len > 1) {
          delete this.uploadCollection[key][index];

          let nk = {};
          let i = 1;
          for (let k in this.uploadCollection[key]) {
            nk[i] = this.uploadCollection[key][k];
            i++;
          }

          this.uploadCollection[key] = nk;
          let fk = key + "PhotoCount";
          this[fk]--;
        }
      } else {
        this.uploadCollection[key] = "";
        this.serverCollection[key] = "";
        //this.saveData('uploadCollection.' + key, '');
        //this.saveData('serverCollection.' + key, '');
      }

      this.$forceUpdate();
    },
    handleSelectResultPage(index = "") {
      event.preventDefault();
      this.showPowerCover = !!index;
      this.resultPageIndex = index;

      //城市选择
      this.isShowCity = false;
      this.cityName = "";
    },
    //暂存数据
    saveData(key, data) {
      let param = {};
      param[key] = data;
      this.setBusinessData(param);
    },
    saveCardResult() {
      event.preventDefault();
      //落地页回来的，直接再回落地页
      if (this.prevStep === 24) {
        this.prevStep = 0;
        this.nextNotice(24);
      } else {
        this.nextNotice(21);
      }
      this.updateCardInfo();
    },

    generateCard() {
      if (!this.notice.one.name) {
        Toast.fail("称呼不能为空！");
        return false;
      }

      let cardParams = {
        index: this.templateStyle
          ? (parseInt(this.templateStyle.substring(4)) || 1)
          : 1,
        head: this.serverCollection.user,
        nick: this.notice.one.name,
        tag: this.customize_tag.replace(/,/g, " "),
        tagimgs: this.customize_tag.replace(/#/g, ""),
        content: this.peopleDeclaration,
      };

      this.cardUrlBtn = false;

      this.$api
        .doPost("/customer/updateCustomer", { nickName: cardParams.nick })
        .then((r) => {
          this.$api
            .doPost("/pic/card", cardParams)
            .then((res) => {
              this.cardUrl = res.path;
              this.notice.one.originName = this.notice.one.name;
              setTimeout(() => {
                this.cardUrlBtn = true;
              }, 500);
            })
            .catch((error) => {
              this.cardUrlBtn = true;
            });
        })
        .catch((error) => {
          this.cardUrlBtn = true;
        });

      this.$api.doPost("/dataMonitor/saveUseAmountData", {
        dataName: `${cardParams.index}`,
        type: 3,
      });

      const tagMap = {
        Foodie: "Hashtag热图01",
        PetLover: "Hashtag热图02",
        "Peace&Love": "Hashtag热图03",
        Gym: "Hashtag热图04",
        Photography: "Hashtag热图05",
        TravelLover: "Hashtag热图06",
        Coffeeholic: "Hashtag热图07",
        Optimist: "Hashtag热图08",
        Basketball: "Hashtag热图09",
        MovieFan: "Hashtag热图10",
        Learner: "Hashtag热图11",
        FashionLover: "Hashtag热图12",
        Creative: "Hashtag热图13",
        Family: "Hashtag热图14",
      }

      let hashTags = cardParams.tagimgs.split(',').map(key => tagMap[key])

      console.log(hashTags.join(','));

      this.$api.doPost("/dataMonitor/saveUseAmountData", {
        // dataName: hashTags.join(','),
        dataName: cardParams.tagimgs,
        type: 4,
      });

    },

    jumpStep(index = 0) {
      let step = this.$route.query.step || 0;
      if (+step === 24 || index === 29) {
        //ignore
      } else {
        this.renderCustomerInfo();
      }

      if (step > 0) {
        this.nextNotice(parseInt(step));
      } else if (index > 0) {
        this.nextNotice(index);
      }
    },
    updateCardInfo() {
      this.saveCustomerInfo(true)
    },
    saveCustomerInfo(skip) {
      let params = {
        serialNo: parseInt(this.templateStyle.substring(4)),
      };
      if (this.serverCollection.user) {
        params.headPic = this.serverCollection.user;
      }

      if (Object.keys(this.serverCollection.cert).length > 0) {
        let cert = [];
        for (let i in this.serverCollection.cert) {
          if (this.serverCollection.cert[i]) {
            cert.push({ imgUrl: this.serverCollection.cert[i] });
          }
        }
        params.certificatesInfo = cert.length
          ? JSON.stringify({ identity: cert })
          : "";
      } else {
        params.certificatesInfo = "";
      }

      if (Object.keys(this.serverCollection.edu).length > 0) {
        let edu = [];
        for (let i in this.serverCollection.edu) {
          if (this.serverCollection.edu[i]) {
            edu.push({ imgUrl: this.serverCollection.edu[i] });
          }
        }
        params.education = edu.length ? JSON.stringify(edu) : "";
      } else {
        params.education = "";
      }

      if (Object.keys(this.serverCollection.report).length > 0) {
        let report = [];
        for (let i in this.serverCollection.report) {
          if (this.serverCollection.report[i]) {
            report.push({ imgUrl: this.serverCollection.report[i] });
          }
        }
        params.medicalReport = report.length ? JSON.stringify(report) : "";
      } else {
        params.medicalReport = "";
      }

      if (Object.keys(this.serverCollection.leave).length > 0) {
        let leave = [];
        for (let i in this.serverCollection.leave) {
          if (this.serverCollection.leave[i]) {
            leave.push({ imgUrl: this.serverCollection.leave[i] });
          }
        }
        params.leaving = leave.length ? JSON.stringify(leave) : "";
      } else {
        params.leaving = "";
      }

      if (this.cardUrl) {
        params.decca = this.cardUrl;
      }

      if (this.peopleDeclaration) {
        params.declaration = this.peopleDeclaration;
      }

      // ^^^^^^
      if (this.customize_tag) {
        let tags = [];
        this.customize_tag.split(",").forEach((v) => {
          tags.push({ tag: v.substring(1, v.length - 1) });
        });
        params.tag = JSON.stringify(tags);
      }

      let tags = Object.keys(this.selectUserTag);
      if (tags.length > 0) {
        let t = [];
        tags.forEach((v) => {
          t.push({ tagImg: v });
        });
        params.tagImage = JSON.stringify(t);
      }

      params.loveSing = [];
      if (this.loveMusic.one) {
        params.loveSing.push({ sing: this.loveMusic.one });
      }
      if (this.loveMusic.two) {
        params.loveSing.push({ sing: this.loveMusic.two });
      }
      params.loveSing = JSON.stringify(params.loveSing);
      params.isGraduate = this.isGraduate ? 1 : 0;
      // if (!params.isGraduate) {
      //   if(params.leaving.length === 0) {
      //     Toast('请上传离职证明')
      //     return
      //   }
      // }
      if (skip === true) {
        this.$api
          .doPost("/customer/updateCustomer", params)
      } else {
        this.$api
          .doPost("/customer/updateCustomer", params)
          .then((res) => {
            this.jumpStep(29);
          })
          .catch((error) => {
            this.jumpStep(29);
          });
      }
    },
    updateTag() {
      const params = {}
      if (this.customize_tag) {
        let tags = [];
        this.customize_tag.split(",").forEach((v) => {
          tags.push({ tag: v.substring(1, v.length - 1) });
        });
        params.tag = JSON.stringify(tags);
      }

      let tags = Object.keys(this.selectUserTag);
      if (tags.length > 0) {
        let t = [];
        tags.forEach((v) => {
          t.push({ tagImg: v });
        });
        params.tagImage = JSON.stringify(t);
      }
      this.$api
        .doPost("/customer/updateCustomer", params)
    },
    getUploadText(key) {
      if ("leave" === key && this.isGraduate) {
        return "应届生，无须上传";
      }

      let result = this.uploadCollection[key];
      let keys = Object.keys(result);
      keys = keys.filter((v) => {
        return result[v];
      });
      if (keys.length > 0) {
        return "已上传";
      }

      return "未上传";
    },
    showCity(name) {
      this.showPowerCover = true;
      this.isShowCity = true;
      this.cityImageIndex = 0;
      this.cityName = name;
    },
    changeCityImage(direction) {
      let len = this.city[this.cityName].images.length - 1;
      let index = this.cityImageIndex;
      if ("left" !== direction) {
        index = index + 1 > len ? 0 : index + 1;
      } else {
        index = index - 1 < 0 ? len : index - 1;
      }
      this.$refs["citySwipe"].swipeTo(index);
      this.cityImageIndex = index;
    },
    changeCityImageSwipe(index) {
      this.cityImageIndex = index;
    },
    loadCityImage(name) {
      try {
        let obj = this.$refs[name];
        if (obj && typeof obj.getBoundingClientRect === "function") {
          let location = this.$refs[name].getBoundingClientRect();
          this.city[name].style =
            "height:" +
            location.height +
            "px; left: " +
            location.left +
            "px; top: " +
            location.top +
            "px";
        }
      } catch (e) {
        //ignore
      }
    },

    findTagByName(name) {
      let rt = null
      this.userTag.forEach((item) => {
        const tag = item.find(uTag => {
          return uTag.name === name
        });
        if (tag) {
          rt = tag;
        }
      });
      return rt
    },

    setCustomerTagName(cTag) {
      for (let i = 0; i < this.userTag.length; i++) {
        const item = this.userTag[i];
        const uTag = item.find(uTag => {
          return uTag.customer && uTag.name === '自定义';
        });
        if (uTag) {
          uTag.name = cTag.tag;
          break;
        }
      }
    },

    initUserTags(customerInfo) {
      if (customerInfo) {
        const { tag, tagImage } = customerInfo;
        let selectTags = []
        let customerTags = []
        let commonTagNames = []

        tag && tag.forEach(tag => {
          tagImage && tagImage.forEach(tagImage => {
            if (tag.tag === tagImage.tagImg) {
              selectTags.push(tag);
            }
          })
        })

        selectTags.forEach(sTag => {
          const uTag = this.findTagByName(sTag.tag);
          if (!uTag) {
            customerTags.push(sTag)
          }
        })

        customerTags.forEach(cTag => {
          this.setCustomerTagName(cTag);
        })

        console.log(customerTags);
      }
    },
    renderCustomerInfo() {
      this.$api.doPost("/customer/customerInfo").then((res) => {
        this.onBoardDto = res.onboardDto || {};
        this.documentCompleteRate = res.finish || 0;
        if (res.customerInfo) {
          let c = res.customerInfo;
          this.notice.one.name = c.nickName;
          this.notice.one.originName = c.nickName;

          if (c.headPic) {
            this.uploadCollection.user = c.headPic;
            this.serverCollection.user = c.headPic;
          }

          if (
            c.certificatesInfo &&
            c.certificatesInfo.identity &&
            c.certificatesInfo.identity.length > 0
          ) {
            if (typeof c.certificatesInfo.identity === "string") {
              c.certificatesInfo.identity = JSON.parse(
                c.certificatesInfo.identity
              );
            }
            c.certificatesInfo.identity.forEach((item, key) => {
              this.uploadCollection.cert[key + 1] =
                item.imgUrl.indexOf(".pdf") > -1
                  ? this.showPdfData
                  : item.imgUrl;
              this.serverCollection.cert[key + 1] = item.imgUrl;
            });
            this.certPhotoCount = c.certificatesInfo.identity.length;
          }

          if (c.education && c.education.length > 0) {
            c.education.forEach((item, key) => {
              this.uploadCollection.edu[key + 1] =
                item.imgUrl.indexOf(".pdf") > -1
                  ? this.showPdfData
                  : item.imgUrl;
              this.serverCollection.edu[key + 1] = item.imgUrl;
            });
            this.eduPhotoCount = c.education.length;
          }

          if (c.medicalReport && c.medicalReport.length > 0) {
            c.medicalReport.forEach((item, key) => {
              this.uploadCollection.report[key + 1] =
                item.imgUrl.indexOf(".pdf") > -1
                  ? this.showPdfData
                  : item.imgUrl;
              this.serverCollection.report[key + 1] = item.imgUrl;
            });
            this.reportPhotoCount = c.medicalReport.length;
          }

          if (c.leaving && c.leaving.length) {
            c.leaving.forEach((item, key) => {
              this.uploadCollection.leave[key + 1] =
                item.imgUrl.indexOf(".pdf") > -1
                  ? this.showPdfData
                  : item.imgUrl;
              this.serverCollection.leave[key + 1] = item.imgUrl;
            });
            this.leavePhotoCount = c.leaving.length;
          }

          if (c.decca) {
            this.cardUrl = c.decca;
          }

          if (c.declaration) {
            this.peopleDeclaration = c.declaration;
          }

          this.initUserTags(c);

          if (c.tag && c.tag.length > 0) {
            let tag = [];
            c.tag.forEach((item) => {
              tag.push("#" + item.tag + "#");
            });
            for (let i = tag.length; i < 3; i++) {
              tag.push("##");
            }
            this.customize_tag = tag.join(",");
          }

          if (c.tagImage && c.tagImage.length > 0) {
            c.tagImage.forEach((sk) => {
              this.userTag.forEach((item) => {
                item.forEach((t) => {
                  if (sk.tagImg === t.name) {
                    t.selected = true;
                    this.selectUserTag[t.name] = t;
                  }
                });
              });
            });
          }

          if (c.loveSing && c.loveSing.length > 0) {
            c.loveSing.forEach((item, k) => {
              if (k === 0) {
                this.loveMusic.one = item.sing;
              } else {
                this.loveMusic.two = item.sing;
              }
            });
          }

          if (c.serialNo) {
            this.templateStyle = "card" + c.serialNo;
          }

          if (c.hasOwnProperty("isGraduate")) {
            this.isGraduate = c.isGraduate;
          }
        }
      });
    },
  },
  mounted() {
    window.onresize = () => {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      if (isAndroid) {
        if (this.originalHeight > document.documentElement.clientHeight) {
          this.showFooterStep = false;
        } else {
          this.showFooterStep = true;
        }
      }
    };
  },
  created() {
    let peopleImage = this.getBusinessData("peopleImage");
    if (peopleImage && this.peopleImage.hasOwnProperty(peopleImage)) {
      this.people = peopleImage;

      this.loadPeopleImage("left", 5);
    }

    this.notice.one.peopleName = this.peopleName[peopleImage] || 'Diane';
    let userInfo = this.getUserInfo();


    if (userInfo.name) {
      this.notice.one.name = userInfo.name;
      this.notice.one.originName = userInfo.name;
      this.notice.one.date = userInfo.entryTimeDate;
      this.notice.one.time = userInfo.entryTimePoint;
      this.notice.one.address =
        (userInfo.hireLication ? userInfo.hireLication : "") +
        (userInfo.entryAddress ? userInfo.entryAddress : "");
      this.notice.one.dept = userInfo.department;
      this.notice.one.sex = userInfo.sex;

      this.notice.two.date = userInfo.trainTimeDate
        ? userInfo.trainTimeDate
        : "";
      this.notice.two.time = userInfo.trainTimePoint
        ? userInfo.trainTimePoint
        : "";
      this.notice.two.address =
        (userInfo.orientation ? userInfo.orientation : "") +
        (userInfo.trainAddress ? userInfo.trainAddress : "");

      this.notice.three.manager = userInfo.managerName;
      this.notice.three.email = userInfo.managerEamil;

      this.entrySureTimeDate = userInfo.entrySureTimeDate;
      this.handbook = userInfo.handbook;
      this.leaving = userInfo.leaving;

      // this.notice.hr.email = userInfo.taEmail;
    }
    if (userInfo.hasOwnProperty("gapEentryDay")) {
      this.notice.one.day = parseInt(userInfo.gapEentryDay) || 0;
      this.dayOnJobCompleteRate = this.notice.one.day * 3.3;
    }
    if (userInfo.hasOwnProperty("gapTrainDay")) {
      this.notice.two.day = parseInt(userInfo.gapTrainDay) || 0;
      this.dayTrainCompleteRate = this.notice.two.day * 3.3;
    }

    let historyData = this.getBusinessData();
    if (historyData && historyData.templateStyle) {
      this.templateStyle = historyData.templateStyle;
    }

    this.jumpStep();

    window.$introduce = this;

    this.isComplete = baseInfoIsDone(userInfo)
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: url("../assets/images/team_bg.jpg") no-repeat center top;
  background-size: cover;
  overflow-y: auto;
}

.line-page {
  background: url("../assets/images/welcome_bg.jpg") no-repeat center top;
  background-size: cover;
  overflow: hidden;
}

.video-page {
  background: url("../assets/images/video_bg.jpg") no-repeat center top;
  background-size: cover;
}

.people-video-page {
  background: url("../assets/images/people_video_bg.jpg") no-repeat center top;
  background-size: 100% 100%;
}

.welcome-page {
  background: url("../assets/images/team_bg.jpg") no-repeat center top;
  background-size: 100% 100%;
}

.right-page {
  background: url("../assets/images/bar_bg.jpg") no-repeat center top;
  background-size: cover;
}

.office-page {
  background: url("../assets/images/office_bg.jpg") no-repeat center top;
  background-size: cover;
}

.card-page {
  background: url("../assets/images/card_bg.jpg") no-repeat center top;
  background-size: cover;
}

.hr-page {
  background: url("../assets/images/hr_bg.jpg") no-repeat center top;
  background-size: cover;
}

.complete-page {
  background: url("../assets/images/complete_bg.jpg") no-repeat center top;
  background-size: cover;
}

.city-page {
  background: url("../assets/images/city_bg.jpg") no-repeat center top;
  background-size: cover;
}

.single-image {
  position: absolute;
  width: 100%;
  height: 100%;
}

.content {
  .left-location-one {
    .left-people {
      position: absolute;
      width: 100%;
      bottom: 7%;
    }

    .left-people-4 {
      bottom: 10%;
    }

    .left-people-9 {
      bottom: 7.5%;
    }
  }

  .right-location-one {
    .right-people {
      position: fixed;
      width: 100%;
      bottom: 7%;
      right: 0;
      pointer-events:none;
    }

    .right-people-40 {
      left: -90px !important;
    }
  }

  .right-location-hr {
    .right-people {
      position: fixed;
      width: 65%;
      bottom: 0;
      right: 0;
    }
  }

  .left-location-two {
    .left-people {
      position: absolute;
      width: 55%;
      bottom: 0;
    }

    .left-people-1,
    .left-people-3,
    .left-people-4,
    .left-people-5,
    .left-people-6,
    .left-people-9,
    .left-people-11,
    .left-people-13,
    .left-people-16,
    .left-people-21,
    .left-people-36 {
      width: 85%;
      left: 0;
    }

    .left-people-6 {
      left: -35%;
    }

    @media only screen and (height: 812px) {
      .left-people {
        position: absolute;
        width: 65%;
        bottom: 0;
      }

      .left-people-1,
      .left-people-3,
      .left-people-4,
      .left-people-5,
      .left-people-6,
      .left-people-9,
      .left-people-11,
      .left-people-13,
      .left-people-16,
      .left-people-21,
      .left-people-36 {
        width: 100%;
        left: 0;
      }

      .left-people-6 {
        left: -50%;
      }
    }
  }

  .right-location-two {
    .right-people {
      position: fixed;
      width: 55%;
      bottom: 0;
      right: 0;
    }

    .right-people-11,
    .right-people-12,
    .right-people-13,
    .right-people-14 {
      width: 85%;
      right: 0;
    }

    .right-people-21 {
      width: 85%;
      right: 0;
    }

    @media only screen and (height: 812px) {
      .right-people {
        position: fixed;
        width: 65%;
        bottom: 0;
        right: 0;
      }

      .right-people-11,
      .right-people-12,
      .right-people-13,
      .right-people-14 {
        width: 100%;
        right: 0;
      }
    }

    .right-people-40 {
      width: 100%;
      left: -40px;
      bottom: -50px;
    }
  }

  .left-location-three {
    .left-people {
      position: absolute;
      width: 100%;
      bottom: 0;
    }

    .left-people-1 {
      width: 50%;
    }

    .left-people-2,
    .left-people-8 {
      width: 63%;
    }
  }

  .right-location-three {
    .right-people {
      position: fixed;
      width: 100%;
      bottom: 0;
      right: 0;
    }

    .right-people-40 {
      left: -50px;
    }
  }

  .overlay {
    background: #f2f2f2;
    z-index: 101;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    height: auto;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }

  .popup {
    position: relative;
    margin: 30px 25px 90px;
    font-size: 16px;
    padding: 10px 10px 10px 20px;
    z-index: 102;
    max-height: 280px;
    min-height: 50px;
    word-break: break-word;
    border: 1px solid #000000;
    border-radius: 30px;
    background: #fff;
  }

  .popup::before {
    content: "";
    position: absolute;
    top: 30%;
    border: 1px solid #000;
    left: -6px;
    width: 10px;
    height: 10px;
    background: inherit;
    -webkit-transform: rotate(45deg);
    border-top-color: #ffffff;
    transform: rotate(45deg);
    border-right-color: #ffffff;
  }

  .popup-1:before {
    top: 37%;
  }

  /*
        .popup-msg-2 {
            background: url('../assets/images/msg_2.png') no-repeat;
            background-size: 100% auto;
        }

        .popup-msg-3 {
            background: url('../assets/images/msg_3.png') no-repeat;
            background-size: 100% 100%;
        }

        .popup-msg-5 {
            background: url('../assets/images/msg_5.png') no-repeat;
            background-size: 100% auto;
            min-height: 140px;
        }

        .popup-msg-6 {
            background: url('../assets/images/msg_6.png') no-repeat;
            background-size: 100% auto;
            min-height: 160px;
        }

        .popup-msg-7 {
            background: url('../assets/images/msg_7.png') no-repeat;
            background-size: 100% auto;
        }

        @media only screen and (height: 736px) {
            .popup-msg-7 {
                min-height: 190px;
            }
        }

        .popup-msg-9 {
            background: url('../assets/images/msg_9.png') no-repeat;
            background-size: 100% auto;
        }

        @media only screen and (height: 736px) {
            .popup-msg-9 {
                min-height: 250px;
            }
        }*/

  .popup-btn {
    position: absolute;
    text-align: center;
    bottom: 20px;
    width: 100%;
    z-index: 98;
  }

  .popup-step {
    position: absolute;
    bottom: 0;
    width: 100%;
    img {
      width: 100%;
    }
  }

  .popup-step-rel {
    position: relative;
    margin-top: 50px;
  }

  @media only screen and (min-height: 812px) {
    .popup-step-rel {
      position: absolute;
    }
  }

  @media only screen and (max-height: 736px) {
    .height-hide-scroll {
      display: none;
    }

    .height-hide-scroll-btn {
      margin-top: 5px !important;
      margin-bottom: 0 !important;
      height: auto;
    }
  }

  /*.popup-step-no {
            position: absolute;
            bottom: -5%;
            width: 111%;
            left: -5.5%;
        }*/

  .black-btn {
    width: 80%;
    background: #2b2b33;
    color: #ffffff;
    font-size: 16px;
    height: 40px;
    border-radius: 30px;
    z-index: 1002;
    opacity: 1;
  }

  .gray-btn {
    background: #e9e8e8;
    bottom: 25px;
    color: #000000;
  }

  .step-btn {
    bottom: 20px;
  }

  .white-btn {
    background: #ffffff;
    border: 1px solid #222222;
    color: #000000;
    opacity: 0.9;
  }

  .video-image {
    opacity: 1;
    z-index: 102;
  }

  .next-page {
    position: fixed;
    width: 150px;
    height: 60px;
    right: -30px;
    line-height: 60px;
    bottom: 60px;
    background: #222222;
    border: 1px solid #222222;
    color: #ffffff;
    font-size: 18px;
    font-weight: bold;
    border-radius: 30px;
    text-indent: 2em;
  }

  @media only screen and (max-height: 667px) {
    .next-page {
      bottom: 55px;
    }
  }

  @media only screen and (max-height: 568px) {
    .next-page {
      bottom: 40px;
    }
  }

  .introduction-video-btn {
    position: fixed;
    width: 30%;
    height: 20%;
    left: 35%;
    top: 40%;
  }

  .card-page-step {
    position: relative;
    margin: 0 auto;
    text-align: center;
    z-index: 100;
    .select-style-diy {
      padding-top: 30%;
      img {
        width: 80%;
      }
    }

    .card-tips {
      font-size: 16px;
      color: #ffffff;
      font-weight: 500;
      letter-spacing: 1px;
      padding-bottom: 20px;
    }

    .card-style-body {
      border: 1px solid #ebbe6b;
      width: 80%;
      margin: 0 auto;
      border-radius: 15px;
      background: #ebbe6b;
      padding: 5px;
      margin-top: 5%;
      /*padding-bottom: 5%;*/

      .card-style-list {
        width: 90%;
        margin: 0 auto;
        margin-top: 10px;
        img {
          width: 90%;
        }

        .card-style-icon {
          height: 36px;
          line-height: 36px;
          background: #ffffff;
          -webkit-border-radius: 30px;
          -moz-border-radius: 30px;
          border-radius: 30px;
          // border: 2px solid #553d40;
          color: #553d40;
          display: flex;
          margin-top: 5px;
          padding: 0 8px;
          .title {
            flex: 1;
            text-align: left;
            text-indent: 0.5em;
          }
          .icon {
            text-align: right;
            margin-right: 5px;
            color: #553D40;
          }
          img {
            width: 30px;
            height: 30px;
            line-height: 30px;
            margin-top: 3px;
            -webkit-filter: drop-shadow(0px 0 0 #553d40);
            filter: drop-shadow(0px 0 0 #553d40);
          }
          input {
            margin: 0 8px;
            width: 100%;
            height: 100%;
            outline: none;
            border: none;
            box-sizing: border-box;
          }
        }

        .icon-selected {
          color: #ffffff;
          background-color: #FF9600;
          font-weight: bold;
          img {
            -webkit-filter: drop-shadow(0px 0 0 red);
            filter: drop-shadow(0px 0 0 red);
          }
        }

        .people-declaration {
          background: transparent;
          color: #553d40;
          font-size: 16px;
          font-weight: 500;
          background: linear-gradient(transparent 97%, #553d40 0);
          background-size: 100% 2em;
          -webkit-background-size: 100% 2em;
          resize: none;
          font-family: inherit;
          outline: none;
          border: none;
          word-break: break-all;
          overflow-x: hidden;
          padding: 0;
          line-height: 2em;
          min-height: 220px;
        }

        .people-music {
          background: transparent;
          color: #553d40;
          font-weight: 500;
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #553d40;
          word-break: break-all;
          overflow-x: hidden;
          padding: 0;
          font-size: 16px;
          text-align: center;
          border-left: none;
          border-top: none;
          border-right: none;
          width: 100%;
          border-radius: unset;
        }

        .people-music:last-child {
          margin-top: 10px;
        }
      }
    }

    #card-result {
      position: relative;
      border: none;
      border-radius: 0;
      min-height: 240px;
      width: 90%;
    }

    @media only screen and (max-height: 568px) {
      #card-result {
        min-height: 180px;
      }
    }

    @media only screen and (min-height: 667px) {
      #card-result {
        min-height: 210px;
      }
    }

    @media only screen and (min-height: 736px) {
      #card-result {
        min-height: 210px;
      }
    }

    @media only screen and (min-width: 360px) {
      #card-result {
        min-height: 200px;
      }
    }

    @media only screen and (min-width: 375px) {
      #card-result {
        min-height: 220px;
      }
    }

    @media only screen and (min-width: 411px) {
      #card-result {
        min-height: 220px;
      }
    }

    @media only screen and (min-width: 414px) {
      #card-result {
        min-height: 240px;
      }
    }

    .select-style {
      padding-top: 2%;
      font-size: 16px;
      color: #ffffff;
      font-weight: 500;
      letter-spacing: 1px;

      img {
        width: 50%;
      }
    }

    .user-add-photo {
      text-align: left;
      margin: 0 auto;
      width: 150px;
      border: 1px solid #e6e2d9;
      height: 150px;
      -webkit-border-radius: 100%;
      -moz-border-radius: 100%;
      border-radius: 100%;

      .user-image-upload {
        width: 150px;
        height: 150px;
        img {
          width: 100%;
        }
        .upbtn {
          position: relative;
          width: 150px;
          height: 150px;
          margin-top: -155px;
        }
      }

      #user-upload-before {
        display: none;
      }

      .user-upload-close-btn {
        position: absolute;
        right: 25%;
        width: 30px !important;
        height: 30px !important;
      }
    }

    .card-style-btn {
      bottom: 10%;
      margin: 0 auto;
      width: 80%;
      height: 50px;
      line-height: 50px;
      margin-top: 20px;
      .prev-btn {
        background: #ffffff;
        color: #2c2b31;
        font-size: 16px;
        height: 40px;
        border: 1px solid #2b2b33;
        border-radius: 30px;
        width: 45%;
      }

      .next-btn {
        border: 1px solid #2b2b33;
        background: #2b2b33;
        color: #ffffff;
        font-size: 16px;
        height: 40px;
        border-radius: 30px;
        width: 45%;
        margin-left: 10%;
      }
    }

    .card-selected {
      box-sizing: border-box;
      border: 3px solid #4d87e2,
    }
    /* 台卡模板 */
    .card1,
    .card2,
    .card3,
    .card4,
    .card5,
    .card6,
    .card7,
    .card8,
    .card9,
    .card10 {
      color: #ffffff;
      .card-user-photo {
        position: absolute;
        left: 10px;
        top: 25%;
        img {
          width: 105px;
          height: 105px;
          -webkit-border-radius: 100%;
          -moz-border-radius: 100%;
          border-radius: 100%;
        }

        @media only screen and (max-height: 568px) {
          img {
            width: 85px;
            height: 85px;
          }
        }
      }

      .card-user-name {
        position: absolute;
        left: 36%;
        font-weight: bold;
        font-size: 18px;
        top: 8%;
        width: 60%;
        text-align: left;
      }

      .card-tag-name {
        position: absolute;
        left: 36%;
        top: 21%;
        border-bottom: 1px solid #ffffff;
        text-align: left;
        width: 60%;
        font-size: 14px;
        img {
          width: 40px;
        }
      }

      .card-tag-icon {
        position: absolute;
        right: 10px;
        top: 27%;
        img {
          width: 24px;
        }
        @media only screen and (max-height: 568px) {
          img {
            width: 26px;
          }
        }
      }

      .card-content {
        position: absolute;
        width: 60%;
        left: 36%;
        top: 40%;
        text-align: left;
        word-break: break-all;
      }
    }

    .card2 {
      color: #d35c1a !important;
      .card-tag-name {
        border-bottom: 1px solid #d35c1a;
      }

      .card-tag-icon {
        img {
          -webkit-filter: drop-shadow(0px 0 0 #d35c1a);
          filter: drop-shadow(0px 0 0 #d35c1a);
        }
      }
    }

    .card3 {
      color: #ebb33e !important;
      .card-tag-name {
        border-bottom: 1px solid #ebb33e;
      }

      .card-user-photo {
        left: auto;
        right: 10px;
        top: 12%;
      }

      .card-user-name {
        top: 23%;
        left: 15px;
        width: 60%;
        height: 43px;
        line-height: 43px;
        border-bottom: 1px solid #ebb33e;
      }

      .card-tag-name {
        left: 100px;
        top: 24%;
        width: 40%;
        border-bottom: none;
      }

      .card-tag-icon {
        top: 55%;
        img {
          position: absolute;
          -webkit-filter: drop-shadow(0px 0 0 #000000);
          filter: drop-shadow(0px 0 0 #000000);
        }

        img:first-child {
          transform: rotate(-8deg);
          right: 40px;
          top: 5px;
        }

        img:nth-child(2) {
          transform: rotate(-30deg);
          right: 15px;
        }

        img:nth-child(3) {
          transform: rotate(-45deg);
          top: -14px;
          right: -8px;
        }
      }

      .card-content {
        top: 43%;
        left: 15px;
      }
    }

    .card4 {
      color: #000000 !important;
      .card-user-photo {
        left: 10px;
        right: auto;
        top: 5%;
      }

      .card-user-name {
        top: 25%;
        left: 41%;
        width: 55%;
        height: 43px;
        line-height: 43px;
        border-bottom: 1px solid #000000;
      }

      .card-tag-name {
        left: auto;
        right: 10px;
        top: 25%;
        width: 40%;
        border-bottom: none;
      }

      .card-tag-icon {
        position: absolute;
        right: auto;
        top: 50%;
        left: 5%;
        img {
          position: absolute;
          -webkit-filter: drop-shadow(0px 0 0 #000000);
          filter: drop-shadow(0px 0 0 #000000);
        }
        img:first-child {
          top: -5px;
          transform: rotate(8deg);
        }

        img:nth-child(2) {
          left: 31px;
          transform: rotate(-5deg);
        }

        img:nth-child(3) {
          left: 60px;
          transform: rotate(-15deg);
          top: -8px;
        }
      }

      .card-content {
        width: 55%;
        left: 41%;
        top: 45%;
      }
    }

    .card5 {
      color: #000000 !important;

      .card-user-photo {
        left: auto;
        right: 10px;
      }

      .card-user-name {
        right: auto;
        left: 15px;
      }

      .card-tag-name {
        left: 15px;
        right: auto;
        border-bottom: 1px solid #000000;
      }

      .card-tag-icon {
        top: 28%;
        left: 40%;
        right: auto;
        img {
          -webkit-filter: drop-shadow(0px 0 0 #000000);
          filter: drop-shadow(0px 0 0 #000000);
        }
      }

      .card-content {
        left: 15px;
      }
    }

    .card6 {
      color: #35638d !important;
      .card-tag-name {
        border-bottom: 1px solid #35638d;
      }

      .card-user-name {
        top: 70%;
        left: 10%;
        width: 20%;
        height: 43px;
        line-height: 43px;
        border-bottom: none;
      }

      .card-tag-name {
        border-bottom: 1px solid #35638d;
      }

      .card-tag-icon {
        top: 28%;
        img {
          -webkit-filter: drop-shadow(0px 0 0 #35638d);
          filter: drop-shadow(0px 0 0 #35638d);
        }
      }

      .card-content {
        top: 40%;
        left: 36%;
      }
    }

    .card7 {
      .card-user-photo {
        top: 38%;
      }

      .card-user-name {
        top: 32%;
      }

      .card-tag-name {
        top: 42%;
      }

      .card-tag-icon {
        top: 49%;
      }

      .card-content {
        top: 60%;
      }
    }

    .card8 {
      color: #ffffff !important;
      .card-tag-name {
        border-bottom: 1px solid #ffffff;
      }

      .card-user-photo {
        left: auto;
        right: 10px;
        top: 12%;
      }

      .card-user-name {
        top: 8%;
        left: 15px;
        width: 60%;
        height: 43px;
        line-height: 43px;
        border-bottom: 1px solid #ffffff;
      }

      .card-tag-name {
        left: 90px;
        border-bottom: none;
        top: 8%;
        border-left: 1px solid #ffffff;
        text-indent: 0.5em;
      }

      .card-tag-icon {
        top: 58%;
        right: 7%;
        img {
          -webkit-filter: drop-shadow(0px 0 0 #ffffff);
          filter: drop-shadow(0px 0 0 #ffffff);
        }
      }

      .card-content {
        top: 28%;
        left: 15px;
      }
    }

    .card9,
    .card10 {
      color: #f3e2d4;
      .card-user-name {
        top: 10%;
        left: 46%;
        width: 50%;
      }

      .card-tag-name {
        left: 46%;
        width: 50%;
      }

      .card-tag-icon {
        top: 27%;
      }

      .card-content {
        left: 46%;
        width: 50%;
      }
    }

    .card10 {
      color: #e2e0da;
    }
  }

  .light {
    .jin {
      width: 60%;
    }
    .point {
      position: absolute;
      width: 30px;
      height: 30px;
      top: 10px;
      left: -5px;
    }
    .jin1 {
      position: absolute;
      top: 31%;
      right: 20%;
      .point {
        left: -15px;
        top: 20px;
      }
    }
    .jin3 {
      position: absolute;
      top: 37%;
      left: 0;
      .point {
        left: -8px;
        top: 30px;
      }
    }
    .jin5 {
      position: absolute;
      top: 46%;
      left: 10px;
      .point {
        top: 30px;
      }
    }
    .jin2 {
      position: absolute;
      right: 10%;
      top: 45%;
      width: 10%;
      .point {
        left: 20px;
        top: 50px;
      }
    }
    .jin4 {
      position: absolute;
      right: 7%;
      top: 66%;
      .jin {
        left: 50px;
      }
      .point {
        left: 50px;
        top: 20px;
      }
    }
    .jin6 {
      position: absolute;
      left: 50%;
      top: 43%;
      .point {
        left: -10px;
      }
    }
    .jin7 {
      position: absolute;
      top: 48%;
      left: 38%;
      .point {
        left: 50px;
        top: 20px;
      }
    }
    .jin8 {
      position: absolute;
      bottom: 30%;
      right: 10%;
      width: 10%;
      .point {
        left: -20px;
      }
    }
    .jin9 {
      position: absolute;
      top: 37%;
      left: 55%;
      .point {
        left: -20px;
        top: 20px;
      }
    }
    .jin10 {
      position: absolute;
      left: 5%;
      top: 45%;
      .point {
        left: -15px;
      }
    }
    .jin11 {
      position: absolute;
      left: 18%;
      top: 36%;
      .jin {
        left: 50px;
      }
      .point {
        left: -15px;
        top: 30px;
      }
    }
    .jin12 {
      position: absolute;
      right: 10%;
      top: 40%;
      width: 10%;
      .point {
        top: 40px;
        left: 25px;
      }
    }
  }

  .popup-light {
    position: fixed;
    width: 80%;
    top: 30%;
    left: 10%;
    z-index: 100;
    .popup-light-close {
      position: absolute;
      right: 0;
      top: -30px;
      text-align: right;
      img {
        width: 60%;
      }
    }
    .popup-light-img {
      width: 100%;
    }
  }

  .upload-info {
    position: absolute;
    width: 90%;
    left: 5%;
    top: 5%;
    z-index: 501;
    background: #ebe7e6;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10%;

    .upload-info-close-btn {
      position: absolute;
      right: 20px;
      top: 20px;
      z-index: 502;
      img {
        width: 22px;
      }
    }

    .upload-item {
      position: relative;
      margin: 20px auto auto;
      width: 85%;
      text-align: center;
    }
    .title {
      .small {
        font-size: 14px;
        font-weight: 400;
      }
    }

    .upload-area-add,
    .join-job-btn {
      margin-top: 5px;
      img {
        vertical-align: bottom;
        height: 24px;
      }
    }

    .join-job-btn {
      color: #c73f45;
      margin-top: 20px;
      margin-bottom: 5px;
    }

    .upload-area {
      min-height: 80px;
      line-height: 80px;
      background: #f4f4f4;
      padding: 5px;
      margin-top: 10px;
      .upload-area-inner {
        border: 1px solid #e4e4e4;
        min-height: 80px;
        line-height: 80px;

        img {
          width: 50px;
          vertical-align: middle;
        }

        .preview-img {
          width: 100% !important;
          height: auto !important;
          -webkit-border-radius: 0;
          -moz-border-radius: 0;
          border-radius: 0;
        }

        .upload-close-btn {
          position: absolute;
          right: -8px;
          width: 30px !important;
          height: 30px !important;
          margin-top: -12px;
        }
        .upload-label-new {
          position: absolute;
          width: 53px;
          height: 65px;
          left: 40%;
          .upbtn {
            position: relative;
            width: 100%;
            height: 100%;
            margin-top: -70px;
            input {
              width: 100%;
              height: 100%;
            }
            .upbtn {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .upload-info-description {
      font-size: 14px;
      background: #f4f4f4;
      text-align: left;
      padding: 15px 0;
      margin-top: 0;
      p {
        padding: 0 15px 0;
        display: flex;
        .small {
          font-size: 13px;
          color: #bbbbbb;
        }
      }
    }
  }

  .complete-result-return {
    position: absolute;
    right: 3%;
    top: 10%;
    width: 30px;
    img {
      width: 30px;
    }
  }

  .complete-result {
    position: absolute;
    height: 42%;
    width: 100%;
    bottom: 0;
    overflow-y: hidden;
    .complete-result-item {
      position: absolute;
      width: 100%;
      height: 100%;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;

      .line {
        width: 40px;
        border-bottom: 1px solid #ffffff;
        margin: 0 auto;
        height: 5%;
      }

      .title {
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        font-weight: 500;
        margin-top: 2%;
        height: 10%;
      }
    }
    .document {
      background-color: #f16043;
      z-index: 100;
      box-shadow: #d8b0a5 0 0 15px;
    }

    .day {
      background-color: #f39a02;
      z-index: 101;
      top: 25%;
      box-shadow: #da5639 0 0 15px;
    }

    .file {
      background-color: #1687af;
      z-index: 102;
      top: 50%;
      box-shadow: #dc7a01 0 0 15px;
      .title {
        margin-top: 4%;
      }
    }

    .question {
      background-color: #19a18d;
      z-index: 103;
      top: 75%;
      box-shadow: #0f709a 0 0 15px;
      .title {
        margin-top: 4%;
      }
    }
  }

  .complete-result-show {
    position: absolute;
    height: 86%;
    width: 100%;
    top: 14%;
    z-index: 502;
    color: #f6ede5;
    font-size: 14px;
    overflow: hidden;

    .complete-result-show-item {
      position: absolute;
      width: 100%;
      height: 100%;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;

      .line {
        width: 40px;
        height: 10px;
        border-top: 1px solid #ffffff;
        padding-top: 10px;
        margin-left: 5%;
        margin-top: 15px;
        .line2 {
          width: 20px;
          border-top: 1px solid #ffffff;
        }
      }

      .show-body {
        width: 90%;
        margin: 0 auto;
        .van-row {
          border-top: 1px solid #f2846c;
          height: 35px;
          padding: 10px;
          img {
            width: 25px;
            vertical-align: text-top;
          }
          .van-col:last-child {
            text-align: right;
          }
        }
        .van-row:first-child {
          border-top: none;
        }

        .name {
          font-size: 24px;
          font-weight: 500;
        }

        /*.sex {
                        margin-left: 10px;
                    }*/

        .rate {
          margin-top: 5px;
          color: #f4c8bb;

          .rate-process {
            height: 18px;
            width: 150px;
            background: #ededed;
            -webkit-border-radius: 10px;
            -moz-border-radius: 10px;
            border-radius: 10px;
            .rate-process-item {
              float: left;
              background: #a03624;
              width: 29px;
              height: 18px;
              border-right: 1px solid #ffffff;
            }
            .rate-process-item:first-child {
              border-top-left-radius: 10px;
              border-bottom-left-radius: 10px;
            }
            .rate-process-item:nth-child(5) {
              width: 30px;
              border-right: none;
              border-top-right-radius: 10px;
              border-bottom-right-radius: 10px;
            }
          }
        }

        .user-photo {
          width: 100px;
          height: 100px;
          line-height: 100px;
          border-radius: 100%;
          margin-top: -22px;
          text-align: center;
          display: inline-block;
          border: 2px solid #d35136;
          .user-photo-img {
            width: 96px;
            height: 96px;
            background: #f7f5ee;
            border-radius: 100%;
            margin: 2px;
            img {
              width: 90px;
              height: 90px;
              margin-top: -40px;
              border-radius: 100%;
            }
          }
        }

        .upload-user-photo-btn {
          width: 100px;
          height: 26px;
          line-height: 26px;
          background: #ffffff;
          border-radius: 30px;
          color: #b26357;
          text-align: center;
          margin-top: 14px;
          display: inline-block;
        }
      }
    }
    .document {
      background-color: #f16043;
    }

    .day {
      background-color: #f39a02;

      .show-body {
        .van-row {
          border-bottom: 1px solid #f5b241;
          height: 160px;
          padding: 10px;
          margin-top: 30px;
          .van-col > div {
            font-size: 14px;
            font-weight: 500;
          }
        }

        .van-row:last-child {
          border-top: none;
        }
      }
    }

    .file {
      background-color: #1687af;
      overflow-y: auto;

      .show-body {
        width: 90%;
        margin: 0 auto;
        /*padding-left: 10px;*/
        padding-top: 20px;

        .big-title {
          padding-top: 15px;
          font-size: 18px;
        }

        .delimiter {
          height: 8px;
        }

        .small {
          color: #bbbbbb;
          font-size: 14px;
        }
      }
    }

    .question {
      background-color: #19a18d;
      overflow-y: auto;

      .show-body {
        width: 90%;
        margin: 0 auto;
        /*padding-left: 10px;*/
        padding-top: 20px;

        .small {
          color: #bbbbbb;
          font-size: 14px;
        }

        .big-title {
          font-size: 15px;
        }

        .delimiter {
          height: 8px;
        }

        .left {
          padding-left: 10px;
        }

        .dot {
          width: 8px;
          height: 8px;
          line-height: 5px;
          border-radius: 100%;
          display: inline-block;
          background: #fff;
          margin-right: 5px;
        }
      }

      table {
        border: 1px solid #ffffff;
        border-collapse: collapse;
        width: 100%;
      }

      table tr {
        display: table-row;
        vertical-align: inherit;
        height: auto;
        border-bottom: 1px solid #ffffff;
        text-align: left;
      }

      table td {
        word-break: break-all;
        word-wrap: break-word;
        border-right: 1px solid #ffffff;
        padding: 5px;
        vertical-align: middle;
      }

      table td:first-child {
        width: 40%;
      }
    }
  }
}

.overlay-notice {
  background: red;
}

.select-cover {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.5;
  z-index: 99;
}

.select-cover-power {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.5;
  z-index: 501;
}

.video {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  top: 0;
  left: 0;

  .popup-light-close {
    position: absolute;
    right: 2%;
    top: 30%;
    text-align: right;
    z-index: 101;
    img {
      width: 60%;
    }
  }
}

.van-cell:not(:last-child)::after {
  border-bottom: none;
}

.preview-img {
  width: 150px !important;
  height: 150px !important;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  border-radius: 100%;
}

.preview-img-info {
  width: 70px !important;
  height: 70px;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  border-radius: 100%;
}

.background-video-btn {
  position: fixed;
  width: 50%;
  right: 0;
  top: 40%;
  height: 17%;
}

.mock-game-msg {
  position: absolute;
  /*top: -40%;*/
  margin: 25px 10px;
  font-size: 16px;
  padding: 15px;
  padding-top: 10px;
  padding-left: 35px;
  z-index: 101;
  max-height: 250px;
  min-height: 80px;
}

.upload-label {
  position: absolute;
  width: 53px;
  height: 65px;
  left: 40%;
  background: url("../assets/images/upload.png") no-repeat;
  background-size: cover;
  margin-top: 10px;
}

.upload-label-new {
  position: absolute;
  width: 53px;
  height: 65px;
  left: 40%;
}

.card-style-body-result {
  margin: 0 auto;
  width: 100%;
  img {
    width: 92%;
  }
}

.city {
  width: 94%;
  margin: 0 auto;
  padding-top: 16%;
  .left {
    padding-top: 15%;
  }
  img {
    width: 100%;
    margin-top: 16px;
  }
  .mock-btn {
    position: absolute;
    width: 46%;
    height: 11.5%;
  }
}

.show-city {
  display: flex;
  justify-content: center;
  position: fixed;
  width: 80%;
  top: 10%;
  max-height: 75%;
  z-index: 502;
  left: 10%;
  background: #ffffff;
  border-radius: 5px;
  padding-top: 10px;
  .left img {
    position: absolute;
    left: -10%;
    top: 12%;
    width: 8%;
  }
  .show-city-center {
    width: 300px;
    min-height: 300px;
  }
  @media only screen and (max-height: 660px) {
    .show-city-center {
      min-height: 300px;
      max-height: 430px;
      overflow-y: auto;
    }
  }
  .center img {
    width: 100%;
  }
  .right img {
    position: absolute;
    right: -10%;
    top: 12%;
    width: 8%;
  }
  .show-city-text {
    font-size: 14px;
    padding: 15px;
    .title {
      font-weight: bold;
      color: #000000;
    }
    div {
      margin-top: 5px;
    }
  }
}
.left-arrow {
  position: absolute;
  height: 60px;
  left: -35px;
  top: 30px;
}
.right-arrow {
  position: absolute;
  height: 60px;
  right: -35px;
  top: 30px;
}
</style>

<style lang="scss">
.tip_logo {
  display: block;
  margin: 100px auto;
  width: 200px;
}
.text-hi {
  font-weight: bold;
  color: #de7802;
}
.right-people {
  pointer-events:none;
}
.my-swipe {
  img {
    width: 100%;
  }
}
</style>
